// /* eslint-disable no-unused-vars */
// /* eslint-disable jsx-a11y/alt-text */
// import React, {
//   useState,
//   useEffect,
//   useCallback,
//   useRef,
//   useContext,
// } from "react";
// import axios from "axios";
// import "./createCatalog.css";
// import "react-toastify/dist/ReactToastify.css";
// import PDFComponent from "./PDFComponent";
// import Select from "react-select";
// import Layout, { Container } from "../../components/layout";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import SearchableSelect from "../../components/searchableSelect";
// import Advanceloader from "../../advanceloader.gif";
// import AllPdfs from "./allPdfs";
// import { Page, pdfjs } from "react-pdf";
// import anyPdf from "./anycopy.pdf";
// import { useUser } from "../../config/userProvider";
// import { RiCloseLargeFill, RiShoppingCartLine } from "react-icons/ri";
// import { BiSearch } from "react-icons/bi";
// import BarcodeScanner from "./barcode";
// import { IoBarcodeOutline } from "react-icons/io5";
// import { IoCloseOutline } from "react-icons/io5";
// import deleteIcon from "../../assets/delete.gif";
// import { AiFillInfoCircle } from "react-icons/ai";
// import { DynamicLoader, InfiLoader } from "../../components/loader";
// import { apiurl } from "../../config/config";
// import Card from "../../components/card";
// import Input from "../../components/inputContainer";
// import { IoMdClose } from "react-icons/io";
// import svg from "../../components/svg";
// import { PdfContext } from "./pdfContext";
// import loader from "../../components/loader";
// import Error from "../../components/error";
// import { MdOutlinePhone, MdOutlinePerson } from "react-icons/md";
// import Pagination from "../../components/pagination";
// import PdfChatBot from "../../components/pdfChatBot";

// const CreateCatalog = () => {
//   const { userData } = useUser();
//   const { choosedPdf } = useContext(PdfContext); // Use the context

//   let vendorObjId = userData?.vendorDetails?.vendorObjId;
//   const [inputValue, setInputValue] = useState("");
//   const [data, setData] = useState([]);
//   const [checkedItems, setCheckedItems] = useState([]);
//   const [selectedItems, setSelectedItems] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [sendingLoader, setSendingLoader] = useState(false);
//   const [searchData, setSearchData] = useState([]);
//   const [combinedData, setCombinedData] = useState([]);
//   const [viewProducts, setViewProducts] = useState(false);
//   const [viewLive, setViewLive] = useState(false);
//   const [generatePdfPopup, setGeneratePdfPopup] = useState(false);
//   const [filterValue, setFilterValue] = useState("");
//   const [storeData, setStoreData] = useState([]);
//   const [selectedStore, setSelectedStore] = useState(null);
//   const [storeManagerPhoneInput, setStoreManagerPhoneInput] = useState("");
//   const [storeManagerInput, setStoreManagerInput] = useState("");
//   const [selectedValue, setSelectedValue] = useState("Select Store");
//   const [activeSection, setActiveSection] = useState("managerInformation");
//   const [productVariants, setProductsVariants] = useState([]);
//   const inputRef = useRef(null);
//   const [sending, setSending] = useState(false);

//   console.log("combinedData", combinedData)

//   // ========================PAGINATION============================
//   const [itemsPerPage, setItemsPerPage] = useState(100);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [paginationData, setPaginationData] = useState("");
//   // ====================================================

//   console.log("User Data Is :", userData);

//   const handleSubmit = (event) => {
//     event.preventDefault();
//     setInputValue("");
//   };

//   // const fetchProductList = async () => {
//   //   setLoading(true);
//   //   const data = {
//   //     vendorObjId: vendorObjId,
//   //   };
//   //   try {
//   //     const response = await axios.post(
//   //       `${apiurl}/admin/v1/product/get`,
//   //       data,
//   //       {
//   //         headers: {
//   //           "Content-Type": "application/json",
//   //         },
//   //       }
//   //     );
//   //     if (response && response.data) {
//   //       setData(response.data.products);
//   //     }
//   //   } catch (error) {
//   //     console.error("Error fetching user list:", error);
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };

//   const fetchProductList = () => {
//     setLoading(true);
//     let data = JSON.stringify({
//       vendorObjId: vendorObjId,
//       page: currentPage,
//       limit: JSON.parse(itemsPerPage),
//     });

//     let config = {
//       method: "post",
//       maxBodyLength: Infinity,
//       url: `${apiurl}/admin/v1/product/get/catalog`,
//       headers: {
//         "Content-Type": "application/json",
//       },
//       data: data,
//     };

//     axios
//       .request(config)
//       .then((response) => {
//         console.log(JSON.stringify(response.data));
//         if (response && response?.data) {
//           setData(response?.data?.products);
//           setPaginationData(response?.data?.pagination);
//           setLoading(false);
//         }
//       })
//       .catch((error) => {
//         setLoading(false);
//         console.log(error);
//       });
//   };

//   useEffect(() => {
//     fetchProductList();
//   }, [currentPage, itemsPerPage]);

//   const handleCheckboxChange = (itemId) => {
//     setCheckedItems((prev) =>
//       prev.includes(itemId)
//         ? prev.filter((id) => id !== itemId)
//         : [...prev, itemId]
//     );
//   };

//   // useEffect(() => {
//   //   const jsonData = data && data.filter((product) =>
//   //     checkedItems.includes(product.id)
//   //   );
//   //   setSelectedItems(jsonData);
//   // }, [data, checkedItems]);

//   useEffect(() => {
//     const jsonData = data
//       ? data.filter((product) => checkedItems.includes(product.id))
//       : [];
//     setSelectedItems(jsonData);
//   }, [data, checkedItems]);

//   console.log("jsonData", data);

//   const handleSearch = (event) => {
//     const value = event.target.value;
//     setInputValue(value);

//     const filteredData =
//       data &&
//       data.filter((product) =>
//         product.variants.some((variant) => variant.barcode === value)
//       );

//     setSearchData(filteredData);
//   };

//   console.log("SEARCH DATA ++++++++> ", searchData);
//   useEffect(() => {
//     setCombinedData([...(selectedItems || []), ...searchData]);
//   }, [selectedItems, searchData]);

//   const removeHandle = (itemID) => {
//     setSearchData((prev) => prev.filter((item) => item._id !== itemID));
//   };

//   const filteredProducts =
//     data &&
//     data.filter((item) => {
//       const lowerCaseFilter = filterValue.toLowerCase();
//       return (
//         item._id.toString().includes(lowerCaseFilter) ||
//         item.title.toLowerCase().includes(lowerCaseFilter)
//       );
//     });

//   const [previousSize, setPreviousSize] = useState(combinedData.length);
//   useEffect(() => {
//     const currentSize = combinedData.length;
//     if (currentSize > previousSize) {
//       toast("Product added successfully!", {
//         type: "success",
//         autoClose: 200,
//         hideProgressBar: true,
//       });
//     } else if (currentSize < previousSize) {
//       toast("Product removed successfully!", { type: "info", autoClose: 200 });
//     }
//     setPreviousSize(currentSize);
//   }, [combinedData, previousSize]);

//   useEffect(() => {
//     if (userData?.storeDetails) {
//       setStoreManagerInput(userData?.name);
//       setStoreManagerPhoneInput(userData?.phone);
//     }
//   }, [userData]);

//   const handleStoreChange = (event) => {
//     setSelectedValue(event.target.value);
//   };

//   // const [currentPage, setCurrentPage] = useState(1);
//   // const recordsPerPage = 50;
//   // const lastIndex = currentPage * recordsPerPage;
//   // const firstIndex = lastIndex - recordsPerPage;
//   // const records =
//   //   filteredProducts && filteredProducts.slice(firstIndex, lastIndex);
//   // // const npage = Math.ceil(filteredProducts.length / recordsPerPage);
//   // const npage = filteredProducts
//   //   ? Math.ceil(filteredProducts.length / recordsPerPage)
//   //   : 0;

//   // const prepage = () => {
//   //   if (currentPage > 1) setCurrentPage(currentPage - 1);
//   // };

//   // const changeCpage = (id) => setCurrentPage(id);

//   // const nextpage = () => {
//   //   if (currentPage < npage) setCurrentPage(currentPage + 1);
//   // };

//   // const buttonsToShow = 10;
//   // const startPage = Math.max(1, currentPage - Math.floor(buttonsToShow / 2));
//   // const endPage = Math.min(npage, startPage + buttonsToShow - 1);
//   // const numbers = Array.from(
//   //   { length: endPage - startPage + 1 },
//   //   (_, index) => startPage + index
//   // );

//   const sendStoreData = {
//     storename: selectedStore?.storename,
//     managername: storeManagerInput,
//     storePhone: storeManagerPhoneInput,
//     storeAddress: selectedStore?.Address,
//     storeCode: selectedStore?.storecode,
//   };

//   const sizeHandle = (code) => {
//     // const filteredData = data.filter((product) =>
//     //   product.variants.some((variant) => variant._id === code)
//     // );

//     console.log("CODECDE", code);
//     console.log("DATA", data);

//     // const filteredData = data.flatMap((product) =>
//     //   product.variants.filter((variant) => variant._id === code)
//     // );

//     const filteredData = data.flatMap((product) =>
//       product.variants
//         .filter((variant) => variant._id === code) // Filter the variants
//         .map((variant) => ({
//           ...variant, // Spread the variant properties
//           productId: product.id, // Include product's `id`
//           productObjId: product._id, // Include product's `_id`
//           productImage: product.image, // Include product's image
//         }))
//     );

//     // console.log("SELECTED PRODUCT IS :",product)

//     setProductsVariants((prev) => [...prev, code]);
//     setSearchData((prev) => [...prev, ...filteredData]);
//     console.log("filteredData", filteredData);
//   };

//   const handleStoreSelect = (option) => {
//     setSelectedValue(option);
//   };

//   const options =
//     storeData &&
//     storeData.map((item) => ({
//       value: item.storename,
//       label: `${item.id}- ${item.storename}`,
//     }));

//   const viewLiveHandle = () => {
//     setViewLive(true);
//     inputRef.current?.focus();
//   };

//   const [numPages, setNumPages] = useState();
//   const [pageNumber, setPageNumber] = useState(1);

//   const onDocumentLoadSuccess = ({ numPages }) => setNumPages(numPages);

//   const [isOpenBarCode, setIsOpenBarCode] = useState(false);
//   const [barCodeResult, setBarCodeResult] = useState("");
//   const [barcodeData, setBarCodeData] = useState([]);
//   const [isBarCodeProductList, setIsBarCodeProductList] = useState(false);
//   // const [isPersonalize, setIsPersonalize] = useState(true);
//   const { isPersonalize, setIsPersonalize } = useUser();
//   const [error, setError] = useState("");
//   const [changedUserData, setChangedUserData] = useState("");

//   const [customerInformation, setCustomerInformation] = useState("");

//   console.log("customerInformation", customerInformation);

//   // const CustomerInputHandler = (e) => {
//   //   const { name, value } = e.target;

//   //   // Process the input value
//   //   let validValue = value;

//   //   // Allow only numeric characters and limit to 10 digits for customerPhone
//   //   if (name === "customerPhone") {
//   //     validValue = value.replace(/[^0-9]/g, "").slice(0, 10);
//   //   }

//   //   // Update the state
//   //   setCustomerInformation((prevState) => ({
//   //     ...prevState,
//   //     [name]: validValue,
//   //   }));
//   // };

//   const CustomerInputHandler = (e) => {
//     const { name, value } = e.target;

//     let validValue = value;

//     if (name === "customerPhone") {
//       // Remove all non-numeric characters
//       let digitsOnly = value.replace(/[^0-9]/g, "");

//       // Remove existing '91' if user tries to type it again
//       if (digitsOnly.startsWith("91")) {
//         digitsOnly = digitsOnly.slice(2);
//       }

//       // Limit to 10 digits after the '91' prefix
//       digitsOnly = digitsOnly.slice(0, 10);

//       // Add '91' prefix
//       validValue = "91" + digitsOnly;
//     }

//     setCustomerInformation((prevState) => ({
//       ...prevState,
//       [name]: validValue,
//     }));
//   };

//   const UpdateCatalogStatus = (status) => {
//     CreateCustomerHandler();
//     const products = searchData.map((item) => ({
//       productObjId: item.productObjId || "",
//       productId: item.productId || "",
//       varientId: item.id || "",
//       varientObjId: item._id || "",
//       sku: item.sku || "",
//       barcode: item.barcode || "",
//     }));

//     if (userData) {
//       const tags = [];
//       tags.push(choosedPdf);
//       let data = JSON.stringify({
//         vendorObjId: vendorObjId,
//         ...(userData.type === "superadmin" && {
//           storeObjId: userData?.storeDetails?.storeObjId,
//         }),
//         userObjId: userData?._id,
//         actionDetails: {
//           products: products,
//           type: status,
//           description: "",
//           tags: tags || [],
//           // articleSKU: "SKU12345",
//           // category: "Winter Collection",
//           // price: "150.00",
//           // discount: "10.00",

//         },
//         catalogDetails: {
//           name: choosedPdf
//         },
//         customerDetails: {
//           name: customerInformation.customerName,
//           phone: customerInformation.customerPhone,
//           customerEmail: customerInformation.customerEmail,
//         },
//       });
//       let config = {
//         method: "post",
//         maxBodyLength: Infinity,
//         url: `${apiurl}/admin/v1/analytic/create`,
//         headers: {
//           "Content-Type": "application/json",
//         },
//         data: data,
//       };

//       axios
//         .request(config)
//         .then((response) => {
//           console.log(JSON.stringify(response.data));
//         })
//         .catch((error) => {
//           console.log(error);
//         });
//     }
//   };

//   const [pdfFile, setPdfFile] = useState();
//   console.log("pdf1234", pdfFile);

//   //  ----------------------------   Email Handler ------------------------------------------
//   const EmailSendHandler = async () => {
//     if (!pdfFile) {
//       setError("No PDF file generated yet");
//       return;
//     }
//     if (!customerInformation?.customerName || !customerInformation?.customerEmail) {
//       setError("Please fill in all required fields");
//       return;
//     }

//     try {
//       setSending(true);
//       const formData = new FormData();
//       formData.append("pdf", pdfFile);
//       formData.append("name", customerInformation.customerName);
//       formData.append("email", customerInformation.customerEmail);

//       const response = await axios.post(
//         `${apiurl}/admin/v1/marketing/EmailWithFileAttachment`,
//         formData,
//         { headers: { "Content-Type": "multipart/form-data" } }
//       );

//       console.log("Email sent successfully:", response.data);
//       if (response.data.success) {
//         setGeneratePdfPopup(false);
//         UpdateCatalogStatus("catalog_sent_email");
//       } else {
//         setError(response.data.message);
//       }
//     } catch (error) {
//       console.error("Error sending email:", error);
//       setError("Failed to send email. Please try again.");
//     } finally {
//       setSending(false);
//     }
//   };
//   //  ----------------------------   Whatsapp Handler ------------------------------------------

//   const WhatsappSendHandler = async () => {
//     // setSendingLoader(true);
//     if (!customerInformation?.customerPhone) {
//       setError("Phone number is missing!");
//       console.error("Error: Phone number is missing!");
//       return;
//     }

//     if (!pdfFile) {
//       setError("PDF file is missing!");
//       // setSendingLoader(false);
//       console.error("Error: PDF file is missing!");
//       return;
//     }

//     try {
//       // Upload the PDF and get the file URL
//       const fileUrl = await FileLinkHandler(pdfFile);
//       if (!fileUrl) {
//         setError("Failed to upload PDF.");
//         setSendingLoader(false);
//         console.error("Failed to retrieve file URL.");
//         return;
//       }
//       // setSendingLoader(false);
//       // Construct the WhatsApp message text
//       const messageText = `Hi ${customerInformation.customerName}, please find the attached PDF here: ${fileUrl}`;

//       // Construct the WhatsApp URL with the phone number and message
//       const whatsappUrl = `https://wa.me/${customerInformation.customerPhone
//         }?text=${encodeURIComponent(messageText)}`;

//       // Debugging WhatsApp URL
//       console.log("WhatsApp URL:", whatsappUrl);

//       // Open WhatsApp in a new tab with the constructed URL
//       window.open(whatsappUrl, "_blank");

//       // Update catalog status
//       UpdateCatalogStatus("catalog_sent_whatsapp");
//     } catch (error) {
//       console.error("Error uploading PDF or sending WhatsApp message:", error);
//       setError("Failed to send the message.");
//     } finally {
//       console.log("Finished handling WhatsApp send action.");
//     }
//   };

//   const FileLinkHandler = async (file) => {
//     setSendingLoader(true);
//     if (!file) {
//       console.error("No file selected.");
//       return null;
//     }

//     const formData = new FormData();
//     formData.append("file", file);

//     try {
//       const response = await axios.post(
//         `${apiurl}/admin/v1/media/document`,
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//           maxBodyLength: Infinity,
//         }
//       );

//       console.log("Upload successful:", response.data);
//       if (response.data.success) {
//         setSendingLoader(false);
//         return response.data?.fileUrl;
//       } else {
//         setSendingLoader(false);
//         console.error(
//           "File upload failed:",
//           response.data.message || "Unknown error"
//         );
//         return null;
//       }
//     } catch (error) {
//       setSendingLoader(false);
//       console.error("Error uploading file:", error.message);
//       return null;
//     }
//   };

//   useEffect(() => {
//     if (error) {
//       setTimeout(() => {
//         setError("");
//       }, 5000);
//     }
//   }, [error]);

//   // =================== PAGINATION =================

//   // Calculate the current items to display
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const CreateCustomerHandler = () => {
//     // Ensure that vendorObjId and customerInformation are available in scope
//     if (
//       !vendorObjId ||
//       !customerInformation ||
//       !customerInformation.customerEmail
//     ) {
//       console.error("Missing required parameters!");
//       return;
//     }

//     const data = JSON.stringify({
//       vendorObjId: vendorObjId,
//       source: "website",
//       email: customerInformation.customerEmail,
//       name: customerInformation.customerName,
//       phone: customerInformation.customerPhone,
//     });

//     const config = {
//       method: "post",
//       maxBodyLength: Infinity,
//       url: `${apiurl}/admin/v1/customer/create/action`,
//       headers: {
//         "Content-Type": "application/json",
//       },
//       data: data,
//     };

//     // Make the API request
//     axios
//       .request(config)
//       .then((response) => {
//         console.log(
//           "Customer created successfully:",
//           JSON.stringify(response.data)
//         );
//       })
//       .catch((error) => {
//         if (error.response) {
//           // Server responded with a non-2xx status code
//           console.error("Error Response:", error.response.status);
//           console.error("Error Data:", error.response.data);
//         } else if (error.request) {
//           // No response received from the server
//           console.error("No response received:", error.request);
//         } else {
//           // Some other error
//           console.error("Error Message:", error.message);
//         }
//       });
//   };

//   return (
//     <Layout>
//       {/* <ChatBot/> */}
//       <Container>
//         {sendingLoader && <InfiLoader maintext="" />}
//         {isOpenBarCode && (
//           <div className="backdrop-blur-md bg-black/60 h-full w-full fixed top-0 left-0 right-0 bottom-0 z-20 flex justify-center items-start ">
//             <button
//               style={{ borderWidth: 1 }}
//               className="absolute right-4 top-4 p-1 border-white text-white rounded-full"
//               onClick={() => setIsOpenBarCode(false)}
//             >
//               <RiCloseLargeFill />
//             </button>
//             <div className="mt-[50%] md:mt-5 m-5 rounded-lg overflow-hidden p-4 relative shadow-lg">
//               <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-l-4 border-gray-300"></div>
//               <div className="absolute top-0 right-0 w-16 h-16 border-t-4 border-r-4 border-gray-300"></div>
//               <div className="absolute bottom-0 left-0 w-16 h-16 border-b-4 border-l-4 border-gray-300"></div>
//               <div className="absolute bottom-0 right-0 w-16 h-16 border-b-4 border-r-4 border-gray-300"></div>
//               <div className="absolute inset-x-0 top-1/2 border-b-2 border-blue-100/50"></div>
//               <BarcodeScanner
//                 barCodeResult={barCodeResult}
//                 setBarCodeResult={setBarCodeResult}
//                 barcodeData={barcodeData}
//                 setBarCodeData={setBarCodeData}
//                 combinedData={combinedData}
//                 setCombinedData={setCombinedData}
//                 data={data}
//               />
//             </div>

//             {isBarCodeProductList && (
//               <div className="absolute h-[80vh] bg-white rounded-xl w-10/12 p-5  top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ">
//                 {barcodeData && barcodeData.map((item, index) => item)}
//               </div>
//             )}

//             <div
//               className={`absolute bottom-5 w-full flex  items-center gap-2 px-3 ${barCodeResult ? "justify-center" : "justify-end"
//                 }`}
//             >
//               {barCodeResult && (
//                 <div className=" bg-white w-11/12 p-2 py-3 rounded-lg ">
//                   {barCodeResult} added successfully
//                 </div>
//               )}

//               <button
//                 className=" bg-blue-500 text-white  p-3 text-4xl rounded-full "
//                 onClick={() => setIsBarCodeProductList(!isBarCodeProductList)}
//               >
//                 {isBarCodeProductList ? (
//                   <IoCloseOutline />
//                 ) : (
//                   <IoBarcodeOutline />
//                 )}
//               </button>

//               <button
//                 className="bg-black text-white  p-3 text-xl rounded-full "
//                 onClick={() => setViewLive(!viewLive)}
//               >
//                 <RiShoppingCartLine />
//               </button>
//             </div>
//           </div>
//         )}
//         <ToastContainer />
//         <div className="bg-white/100 h-full overflow-auto">
//           {loading ? (
//             <InfiLoader maintext="Fetching Catalog Data..." />
//           ) : (
//             <div className=" h-full overflow-auto">
//               <div className="sticky top-0 z-20 bg-zinc-100 px-1.5 lg:px-4 py-2 grid grid-cols-2  md:flex justify-between  gap-2 rounded-lg shadow flex-wrap md:flex-nowrap">
//                 <button
//                   className="bg-zinc-950 px-2 text-white rounded lg:hidden text-2xl w-10 flex justify-center items-center lg:w-auto"
//                   onClick={() => setIsOpenBarCode(true)}
//                 >
//                   <IoBarcodeOutline />
//                 </button>
//                 <form
//                   onSubmit={handleSubmit}
//                   className="hidden md:flex items-center gap-2"
//                 >
//                   <Input.Normal
//                     autoFocus
//                     value={inputValue}
//                     className="lg:text-[0.9rem] text-xs py-2"
//                     type="text"
//                     placeholder="Scan Barcode"
//                     onChange={handleSearch}
//                     ref={inputRef}
//                   />
//                   <div className="relative group">
//                     <AiFillInfoCircle className="text-gray-500 hover:text-gray-700 transition-colors duration-200 cursor-pointer" />
//                     <div className="absolute text-nowrap z-20 hidden group-hover:block bg-white text-gray-800 text-sm rounded-md py-2 px-3 left-1/2 transform -translate-x-1/2 top-full mt-2 shadow-lg border border-gray-200 transition-opacity duration-200 opacity-0 group-hover:opacity-100">
//                       <span className="block capitalize">
//                         For scanning by a machine focus on this input
//                       </span>
//                       <span className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-3 h-3 bg-white border-l border-t border-gray-200 rotate-45"></span>
//                     </div>
//                   </div>
//                 </form>

//                 <div className="w-full col-span-2  md:w-1/2 relative group">
//                   <Input.Normal
//                     type="text"
//                     placeholder="Global Search...."
//                     className="lg:text-[0.9rem] text-xs py-2 lg:w-full hover:border-gray-500 transition duration-200"
//                     value={filterValue}
//                     onChange={(e) => setFilterValue(e.target.value)}
//                   />
//                   <BiSearch className="text-xl absolute right-3 top-1/2 -translate-y-1/2 group-hover:text-black text-zinc-300 transition duration-200" />
//                 </div>

//                 <div className=" flex row-start-1 col-start-2 items-center justify-end gap-2 border-l lg:border-none  lg:gap-3 ">
//                   {/* <div className="mx-3 w-50 liveAddedBtn"> */}
//                   <div className="relative">
//                     <button
//                       className="p-[0.3rem] relative flex justify-center items-center text-xl  hover:bg-zinc-950 hover:text-white  rounded  "
//                       onClick={viewLiveHandle}
//                     >
//                       <RiShoppingCartLine />
//                     </button>
//                     <div className="bg-black flex justify-center items-center text-white text-[0.6rem]  w-3 h-3 rounded-full absolute -right-0 -top-0">
//                       {searchData.length}
//                     </div>
//                   </div>
//                   {/* </div> */}
//                   {userData?.storeDetails?.storeObjId ? <button
//                     className={`w-full text-[0.7rem] lg:text-[1rem] lg:p-1 lg:px-3 p-1.5 px-4 rounded ${combinedData?.length === 0
//                       ? "bg-gray-300 text-gray-500"
//                       : "bg-zinc-950 text-white"
//                       } `}
//                     disabled={combinedData?.length === 0}
//                     onClick={() => {
//                       setGeneratePdfPopup(true);
//                       UpdateCatalogStatus("catalog_generated");
//                     }}
//                   >
//                     Generate
//                   </button> :
//                     <button
//                       className={`w-full text-[0.7rem] lg:text-[1rem] lg:p-1 lg:px-3 p-1.5 px-4 rounded ${combinedData?.length === 0
//                         ? "bg-gray-300 text-gray-500"
//                         : "bg-zinc-700 text-white"
//                         } `}
//                       disabled={combinedData?.length === 0}
//                       onClick={() => {
//                         toast.error("You have not assigned any store.")
//                       }}
//                     >
//                       Generate
//                     </button>}

//                 </div>
//               </div>

//               <div className="h-86 sm:h-full w-full">
//                 <div className="productSection w-full">
//                   <div className=" h-full w-full mt-3 md:mt-5   ">
//                     <div className="flex  md:hidden flex-col gap-2">
//                       {data &&
//                         data.map((item, index) => (
//                           <div className="flex items-start gap-1">
//                             <label className="p-1 px-2 rounded-sm bg-zinc-50 font-medium">
//                               {index + 1}
//                             </label>

//                             <div className="flex justify-center items-center">
//                               <img
//                                 className="max-h-24 max-w-24 w-2/5 rounded"
//                                 src={item?.image ?? "/imageNotFound.png"}
//                                 alt={item?.title}
//                                 style={{ objectFit: "cover" }}
//                               />
//                               <div className="p-2 ">
//                                 <div className="text-sm">{item?.title}</div>
//                                 <div className="text-xs mt-2 bg-zinc-50 p-2 rounded">
//                                   <label className="font-medium">
//                                     Product Size
//                                   </label>
//                                   <div className="text-xs mt-1">
//                                     <VariantSku
//                                       item={item}
//                                       sizeHandle={sizeHandle}
//                                       padding="px-2 p-1"
//                                     />
//                                   </div>
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         ))}
//                     </div>

//                     <div class=" md:block hidden relative w-full h-full overflow-y-auto shadow-md sm:rounded-lg ">
//                       <table class="w-full text-sm text-left rtl:text-right text-gray-500 ">
//                         <thead class="text-xs text-gray-700 uppercase bg-gray-50  ">
//                           <tr className="">
//                             <th scope="col" class="px-6 py-3">
//                               #
//                             </th>
//                             <th scope="col" class="px-6 py-3">
//                               Image
//                             </th>
//                             <th scope="col" class="px-6 py-3">
//                               Title
//                             </th>
//                             <th scope="col" class="px-6 py-3">
//                               Product Add By Size
//                             </th>
//                             <th scope="col" class="px-6 py-3">
//                               <select
//                                 value={itemsPerPage}
//                                 className="text-xs rounded text-black border px-2"
//                                 onChange={(e) =>
//                                   setItemsPerPage(e.target.value)
//                                 }
//                               >
//                                 {/* <option value="10">10</option> */}
//                                 {/* <option value="50">50</option> */}
//                                 <option value="100">100</option>
//                                 <option value="250">250</option>
//                                 <option value="500">500</option>
//                                 <option value="1000">1000</option>
//                               </select>
//                             </th>
//                           </tr>
//                         </thead>

//                         <tbody>
//                           {data &&
//                             data.map((item, index) => (
//                               <tr key={item.id} className="  border-b ">
//                                 <th
//                                   scope="row"
//                                   class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap "
//                                 >
//                                   {index + 1}
//                                 </th>
//                                 <td class="px-6 py-4">
//                                   <label
//                                     htmlFor={`${item.id}`}
//                                     className="cursor-pointer"
//                                   >
//                                     <img
//                                       src={item.image ?? "/imagenotFound.png"}
//                                       alt=""
//                                       className="w-24 rounded "
//                                     />
//                                   </label>
//                                 </td>
//                                 <td class="px-6 py-4">
//                                   <label className="cursor-pointer">
//                                     {item?.title}
//                                   </label>
//                                 </td>
//                                 <td class="px-6 py-4">
//                                   <VariantSku
//                                     item={item}
//                                     sizeHandle={sizeHandle}
//                                   />
//                                 </td>
//                                 <td></td>
//                               </tr>
//                             ))}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                   {/* <div className="flex justify-center m-1 sticky bottom-0 backdrop-blur-md bg-white">
//                     <button className="product_neo_btn" onClick={prepage}>
//                       Previous
//                     </button>
//                     {numbers &&
//                       numbers.map((n, i) => (
//                         <div
//                           className={`page-item ${
//                             currentPage === n ? "active" : ""
//                           }`}
//                           key={i}
//                         >
//                           <button
//                             className={`product_neo_btn ${
//                               currentPage === n ? "active-page-button" : ""
//                             }`}
//                             onClick={() => changeCpage(n)}
//                           >
//                             {n}
//                           </button>
//                         </div>
//                       ))}
//                     <button className="product_neo_btn" onClick={nextpage}>
//                       Next
//                     </button>
//                   </div> */}

//                   <div className="flex justify-center m-1 sticky bottom-0 backdrop-blur-md bg-white">
//                     <Pagination
//                       currentPage={currentPage}
//                       totalItems={paginationData?.totalItems}
//                       itemsPerPage={itemsPerPage}
//                       onPageChange={handlePageChange}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>

//         {/* {viewLive && ( */}
//         <div
//           className={`fixed z-50 bg-white lg:w-1/4 w-11/12 h-[95%] lg:h-screen p-4 lg:p-6 transition-all duration-500 ease-in-out
//           ${viewLive ? "opacity-100" : "opacity-0 pointer-events-none"}
//           lg:left-0 lg:top-0 lg:rounded-r-3xl lg:drop-shadow-xl
//           bottom-0 left-1/2 -translate-x-1/2 rounded-t-lg shadow-xl
//           ${viewLive
//               ? "lg:translate-x-0 translate-y-0 lg:translate-y-0"
//               : "lg:-translate-x-full translate-y-full lg:-translate-y-0"
//             }`}
//         >
//           <div className="flex justify-between items-center">
//             <p>
//               <span className="text-2xl font-semibold">Products</span>
//               <span className="bg-blue-50 border border-blue-300 text-blue-600 px-2 ml-2 rounded">
//                 {searchData.length}
//               </span>
//             </p>
//             <button
//               type="button"
//               className="btn mb-3 btn-outline-secondary text-zinc-400 hover:text-black "
//               onClick={() => setViewLive(false)}
//             >
//               <RiCloseLargeFill />
//             </button>
//           </div>
//           {searchData.length > 0 ? (
//             <div className="viewliveContent flex flex-col gap-4">
//               {searchData.map((item) => {
//                 console.log("item?.image", item)
//                 return (
//                   <div
//                     className="border-b flex gap-4 py-4"
//                     id={`${item?._id}`}
//                     key={item?._id}
//                   >
//                     <div>
//                       <img
//                         src={item?.productImage ? item?.productImage : item?.image}
//                         alt=""
//                         className="rounded w-28"
//                       />
//                     </div>
//                     <div className="flex justify-between w-full">
//                       <div className="flex flex-col gap-0.5 items-start">
//                         <div className="flex flex-col items-start">
//                           <p className="text-[0.6rem] md:text-xs bg-zinc-50 px-3 sm:px-2 py-0.5 rounded text-zinc-400 hover:text-zinc-800">
//                             <i>{item?.barcode}</i>
//                           </p>
//                           <label className="text-sm lg:text-xl font-semibold">
//                             {item?.title}
//                           </label>
//                         </div>
//                         <p className="border p-1 px-2 rounded text-[0.6rem] lg:text-sm text-zinc-600">
//                           {item?.size}
//                         </p>
//                       </div>
//                       <div className="flex items-start cursor-pointer">
//                         <button
//                           className="btn m-0"
//                           onClick={() => removeHandle(item._id)}
//                           aria-label="Remove item"
//                         >
//                           <svg
//                             xmlns="http://www.w3.org/2000/svg"
//                             viewBox="0 0 64 64"
//                             fill="none"
//                             stroke="currentColor"
//                             strokeWidth="2.04"
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             width={25}
//                           >
//                             <g>
//                               <path d="M37.444,19.092v-2.207c0-2.074-1.682-3.756-3.756-3.756h-3.377c-2.074,0-3.756,1.682-3.756,3.756v2.207" />
//                             </g>
//                             <g>
//                               <path
//                                 fill="#FFFFFF"
//                                 d="M48.482,21.551c0,1.358-1.247,2.459-2.787,2.46l-27.39,0.006c-1.54,0-2.788-1.101-2.788-2.46v-0.006c0-1.358,1.248-2.46,2.787-2.46h27.39C47.235,19.092,48.482,20.193,48.482,21.551z"
//                               />
//                               <path
//                                 fill="#FFFFFF"
//                                 d="M18.427,42.902V24.017h27.147v18.884c0,4.401-3.568,7.969-7.969,7.969H26.396C21.995,50.871,18.427,47.303,18.427,42.902z"
//                               />
//                             </g>
//                             <g>
//                               <line
//                                 x1="26.556"
//                                 y1="29.461"
//                                 x2="28.371"
//                                 y2="43.979"
//                               />
//                               <line
//                                 x1="37.88"
//                                 y1="29.461"
//                                 x2="36.066"
//                                 y2="43.979"
//                               />
//                             </g>
//                           </svg>
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 )
//               })}
//             </div>
//           ) : (
//             <div className="w-full h-full flex justify-center items-center">
//               <div className="bg-zinc-50 text-zinc-600 rounded-md border border-zinc-300 p-10">
//                 <h2>Cart is empty!</h2>
//               </div>
//             </div>
//           )}
//         </div>
//         {/* )} */}

//         {generatePdfPopup && (
//           <Card.AddPopUp
//             removePopUp={() => setGeneratePdfPopup(false)}
//             className="transition-all duration-500 "
//             // maxHeight="70%"
//             height="auto"
//           >
//             {/* <div
//             className="overlaydiv"
//             onClick={() => setGeneratePdfPopup(false)}
//           ></div> */}

//             <div className=" p-4 py-2  rounded  text-xs md:text-base ">
//               <div className="flex justify-between items-start sticky top-0 bg-white">
//                 <div className="flex flex-col text-zinc-800 ">
//                   <div className="font-semibold md:font-bold text-lg md:text-2xl capitalize">
//                     {userData?.storeDetails?.storeName}
//                   </div>
//                 </div>
//               </div>

//               <div className="">
//                 <div className="mb-4 gap-2 md:gap-4 shadow border  rounded-md p-3 mt-4">
//                   <p className="font-semibold text-lg">Store Information</p>
//                   <div className="p-3 text-slate-700 flex flex-col gap-2  ">
//                     <div className="grid grid-cols-2">
//                       <p className="flex items-center gap-2 font-semibold">
//                         <span className="text-lg">
//                           <MdOutlinePerson />
//                         </span>{" "}
//                         Store Manager Name
//                       </p>
//                       <p>{storeManagerInput}</p>
//                     </div>
//                     <div className="grid grid-cols-2">
//                       <p className="flex items-center gap-2 font-semibold">
//                         <span className="text-lg">
//                           <MdOutlinePhone />
//                         </span>{" "}
//                         Phone Number
//                       </p>
//                       <p>{storeManagerPhoneInput}</p>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="my-4 bg-white ">
//                   <div className="flex flex-col md:flex-row md:items-center justify-between">
//                     <div className="flex items-center gap-2">
//                       {/* <input
//                         type="checkbox"
//                         id="toggleCard"
//                         className="cursor-pointer"
//                         checked={isPersonalize}
//                         onChange={(e) => {
//                           setIsPersonalize(e.target.checked);
//                         }}
//                       /> */}

//                       <label class="inline-flex items-center cursor-pointer">
//                         <input
//                           type="checkbox"
//                           className="sr-only peer"
//                           checked={isPersonalize}
//                           onChange={(e) => {
//                             setIsPersonalize(e.target.checked);
//                           }}
//                         />
//                         <div class="relative w-9 h-5 bg-gray-200 peer-focus:outline-none    rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all  peer-checked:bg-blue-600"></div>
//                         <span class="ms-3 text-sm font-medium text-gray-900 ">
//                           Personalize
//                         </span>
//                       </label>
//                       {/*
//                       <label
//                         htmlFor="toggleCard"
//                         className="block text-gray-500 font-medium "
//                       >
//                         Personalize
//                       </label> */}
//                     </div>
//                     <div className="text-xs md:text-sm px-3 rounded bg-blue-50 border border-blue-400 text-blue-700">
//                       Fill Customer's Information
//                     </div>
//                   </div>
//                   {/* {isPersonalize && ( */}
//                   {isPersonalize && (
//                     <div
//                       id="toggleCardTarget"
//                       className={`flex flex-col gap-2 my-3  ease-in-out transition-all duration-500 `}
//                     >
//                       <div className=" flex md:flex-row flex-col gap-2 md:gap-4">
//                         <Input.Normal
//                           label="Customer name"
//                           type="text"
//                           className=""
//                           name="customerName"
//                           placeholder="Name"
//                           value={customerInformation?.customerName}
//                           onChange={CustomerInputHandler}
//                         />

//                         <Input.Normal
//                           label="Customer Phone Number"
//                           type="text"
//                           className=""
//                           placeholder="Phone Number"
//                           name="customerPhone"
//                           value={customerInformation?.customerPhone}
//                           onChange={CustomerInputHandler}
//                         />
//                       </div>
//                       <Input.Normal
//                         label="Customer email"
//                         type="text"
//                         className=""
//                         name="customerEmail"
//                         placeholder="Email"
//                         value={customerInformation?.customerEmail}
//                         onChange={CustomerInputHandler}
//                       />
//                       {/* <Input.textArea
//                       label="Customer address"
//                       type="text"
//                       className=""
//                       rows="4"
//                       name="customerAddress"
//                       placeholder=" address"
//                       value={customerInformation?.customerAddress}
//                       onChange={CustomerInputHandler}
//                     /> */}
//                     </div>
//                   )}
//                 </div>

//                 {activeSection === "storeInformation" && (
//                   <>
//                     <div className="mb-4">
//                       <label
//                         htmlFor="storeName"
//                         className="block text-gray-500 font-medium mb-2"
//                       >
//                         Store Name
//                       </label>
//                       <Input.Normal
//                         type="text"
//                         id="storeName"
//                         className=""
//                         value={userData?.storeDetails?.storeName}
//                         onChange={(e) =>
//                           setChangedUserData((prev) => ({
//                             ...prev,
//                             storeDetails: {
//                               ...prev.storeDetails,
//                               storeName: e.target.value,
//                             },
//                           }))
//                         }
//                       />
//                     </div>

//                     <div className="mb-4">
//                       <label
//                         htmlFor="storeEmail"
//                         className="block text-gray-500 font-medium mb-2"
//                       >
//                         Store Email
//                       </label>
//                       <Input.Normal
//                         type="email"
//                         id="storeEmail"
//                         className=""
//                         value={userData?.storeDetails?.storeEmail}
//                         onChange={(e) =>
//                           setChangedUserData((prev) => ({
//                             ...prev,
//                             storeDetails: {
//                               ...prev.storeDetails,
//                               storeEmail: e.target.value,
//                             },
//                           }))
//                         }
//                       />
//                     </div>

//                     <div className="mb-4">
//                       <label
//                         htmlFor="storeAddress"
//                         className="block text-gray-500 font-medium mb-2"
//                       >
//                         Store Address
//                       </label>
//                       <Input
//                         type="text"
//                         id="storeAddress"
//                         className=""
//                         value={userData?.storeDetails?.storeAddress}
//                         onChange={(e) =>
//                           setChangedUserData((prev) => ({
//                             ...prev,
//                             storeDetails: {
//                               ...prev.storeDetails,
//                               storeAddress: e.target.value,
//                             },
//                           }))
//                         }
//                       />
//                     </div>
//                   </>
//                 )}
//                 <div className="bg-zinc-50 border rounded-md">
//                   <Input.Normal
//                     label="Choose Your Perfect PDF"
//                     isInput={false}
//                     labelClassName="mt-2 p-0"
//                   />
//                   <div className="flex justify-evenly gap-5 md:mt-1 ">
//                     <AllPdfs
//                       data={{ Product: combinedData, Store: sendStoreData }}
//                     />
//                     {/* {selectedStore && (
//                   <div className="card text-left my-3">
//                     <div className="card-body">
//                       <h4 className="">
//                         Store Name: {selectedStore?.storename}
//                       </h4>
//                       <h5 className="">
//                         Store Code: {selectedStore?.storecode}
//                       </h5>
//                       <p className="card-text">
//                         Address: {selectedStore?.Address}
//                       </p>
//                     </div>
//                   </div>
//                 )} */}
//                   </div>
//                 </div>

//                 <div className="flex justify-between items-center gap-3 mt-3 ">
//                   {isPersonalize && (
//                     <div className="flex items-center gap-2  mt-3 capitalize">
//                       {/* <button
//                         className="px-3 py-1 border rounded-md flex items-center gap-2 hover:text-green-700 text-nowrap "
//                         onClick={() => {
//                           setGeneratePdfPopup(false);
//                           UpdateCatalogStatus("catalog_sent_whatsapp");
//                         }}
//                       >
//                         <svg.whatsapp className="cursor-pointer" />
//                         <span>Whatsapp</span>
//                       </button> */}
//                       <button
//                         className="px-3 py-1 border rounded-md flex items-center gap-2 hover:text-red-700 text-nowrap "
//                         onClick={EmailSendHandler}
//                       >
//                         <svg.gmail className="cursor-pointer" />
//                         {sending === true ? (
//                           <loader.staggerCircle color="#fd1f1a" />
//                         ) : (
//                           <span>Gmail</span>
//                         )}
//                       </button>
//                       <button
//                         className="px-3 py-1.5 border rounded-md flex cursor-pointer items-center gap-2 hover:text-green-700 text-nowrap w-28"
//                         onClick={WhatsappSendHandler}
//                       >
//                         {/* <svg.gmail className="cursor-pointer" /> */}
//                         <img src="/whatsappShare.png" className="w-8 h-auto" />
//                         <span>Share</span>
//                       </button>
//                     </div>
//                   )}

//                   <PDFComponent
//                     data={{
//                       Product: combinedData,
//                       Store: sendStoreData,
//                       Customer: customerInformation,
//                     }}
//                     submitData={UpdateCatalogStatus}
//                     setPdfFile={setPdfFile}
//                     pdfFile={pdfFile}
//                   />
//                 </div>
//                 {error && (
//                   <Error
//                     err={error}
//                     absolute={true}
//                     className="mt-2"
//                   // className="fixed  left-1/2 -translate-x-1/2 top-12 z-10"
//                   />
//                 )}
//               </div>
//             </div>
//           </Card.AddPopUp>
//         )}
//       </Container>
//     </Layout>
//   );
// };
// export default CreateCatalog;

// export const VariantSku = ({ item, sizeHandle, padding, margin }) => {
//   console.log("item", item);
//   return (
//     <label htmlFor={`${item.id}`} className="cursor-pointer">
//       {item?.variants?.map((variant) => (
//         <button
//           className={`bg-transparent border text-gray-700   rounded hover:bg-blue-100 hover:border-blue-200 ${padding ? padding : "p-2 px-3"
//             } ${margin ? margin : "m-1"} `}
//           onClick={() => {
//             sizeHandle(variant?._id);
//             console.log("CODECDE", variant?._id);
//           }}
//           key={variant?._id}
//         >
//           {variant.size}
//         </button>
//       ))}
//     </label>
//   );
// };

// // const Input = ({
// //   id,
// //   type,
// //   placeholder,
// //   onChange,
// //   value,
// //   ariadescribedby,
// //   isDisable,
// //   label,
// //   className,
// // }) => (
// //   <div className="flex flex-col">
// //     {label && (
// //       <label className="font-medium text-sm" htmlFor="storeName">
// //         {label}
// //       </label>
// //     )}
// //     <input
// //       type={type ? type : "text"}
// //       style={{ borderWidth: 1 }}
// //       className={`w-full py-2 px-2 rounded-md outline-none bg-white ${className} `}
// //       id={id}
// //       placeholder={placeholder ? placeholder : ""}
// //       aria-describedby={ariadescribedby ? ariadescribedby : ""}
// //       value={value}
// //       onChange={onChange}
// //       // {...props}
// //     />
// //   </div>
// // );

// // const Input = ({ onChange, value, className, ...props }) => (
// //   <input
// //     className={`bg-white border p-1 rounded outline-none text-base px-3 ${className}`}
// //     onChange={onChange}
// //     value={value}
// //     {...props}
// //   />
// // );

/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/alt-text */

// import React, {
//   useState,
//   useEffect,
//   useCallback,
//   useRef,
//   useContext,
// } from "react";
// import axios from "axios";
// import "./createCatalog.css";
// import "react-toastify/dist/ReactToastify.css";
// import PDFComponent from "./PDFComponent";
// import Layout, { Container } from "../../components/layout";
// import { ToastContainer, toast } from "react-toastify";
// import { RiCloseLargeFill, RiShoppingCartLine } from "react-icons/ri";
// import { BiSearch } from "react-icons/bi";
// import BarcodeScanner from "./barcode";
// import { IoBarcodeOutline, IoCloseOutline } from "react-icons/io5";
// import { AiFillInfoCircle } from "react-icons/ai";
// import { InfiLoader } from "../../components/loader";
// import { apiurl } from "../../config/config";
// import Card from "../../components/card";
// import Input from "../../components/inputContainer";
// import { PdfContext } from "./pdfContext";
// import Error from "../../components/error";
// import { MdOutlinePerson, MdOutlinePhone } from "react-icons/md";
// import Pagination from "../../components/pagination";
// import AllPdfs from "./allPdfs";
// import { useUser } from "../../config/userProvider";
// import { FaTrash } from "react-icons/fa6";
// import svg from "../../components/svg";
// import loader from "../../components/loader";

// const CreateCatalog = () => {
//   const { userData } = useUser();
//   const { choosedPdf } = useContext(PdfContext);
//   const vendorObjId = userData?.vendorDetails?.vendorObjId;

//   const [inputValue, setInputValue] = useState("");
//   const [data, setData] = useState([]);
//   const [checkedItems, setCheckedItems] = useState([]);
//   const [selectedItems, setSelectedItems] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [sendingLoader, setSendingLoader] = useState(false);
//   const [searchData, setSearchData] = useState([]);
//   const [combinedData, setCombinedData] = useState([]);
//   const [viewLive, setViewLive] = useState(false);
//   const [generatePdfPopup, setGeneratePdfPopup] = useState(false);
//   const [filterValue, setFilterValue] = useState("");
//   const [storeManagerPhoneInput, setStoreManagerPhoneInput] = useState("");
//   const [storeManagerInput, setStoreManagerInput] = useState("");
//   const [itemsPerPage, setItemsPerPage] = useState(100);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [paginationData, setPaginationData] = useState("");
//   const [pdfFile, setPdfFile] = useState();
//   const [isOpenBarCode, setIsOpenBarCode] = useState(false);
//   const [barCodeResult, setBarCodeResult] = useState("");
//   const [barcodeData, setBarCodeData] = useState([]);
//   const [isBarCodeProductList, setIsBarCodeProductList] = useState(false);
//   const { isPersonalize, setIsPersonalize } = useUser();
//   const [error, setError] = useState("");
//   const [customerInformation, setCustomerInformation] = useState({});
//   const inputRef = useRef(null);
//   const searchInputRef = useRef(null);
//   const [sending, setSending] = useState(false);

//   // Load selected items from local storage on mount
//   useEffect(() => {
//     const savedItems = localStorage.getItem("selectedItems");
//     if (savedItems) {
//       setSearchData(JSON.parse(savedItems));
//     }
//   }, []);

//   // Save selected items to local storage whenever searchData changes
//   useEffect(() => {
//     localStorage.setItem("selectedItems", JSON.stringify(searchData));
//   }, [searchData]);

//   // Focus on global search input on mount
//   useEffect(() => {
//     searchInputRef.current?.focus();
//   }, []);

//   // Fetch product list from API
//   const fetchProductList = useCallback(() => {
//     if (!vendorObjId || filterValue) return; // Skip if search is active
//     setLoading(true);
//     const data = JSON.stringify({
//       vendorObjId,
//       page: currentPage,
//       limit: parseInt(itemsPerPage),
//     });

//     const config = {
//       method: "post",
//       maxBodyLength: Infinity,
//       url: `${apiurl}/admin/v1/product/get/catalog`,
//       headers: { "Content-Type": "application/json" },
//       data,
//     };

//     axios
//       .request(config)
//       .then((response) => {
//         if (response?.data?.products) {
//           setData(response.data.products);
//           setPaginationData(response.data.pagination);
//         }
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error("Error fetching product list:", error);
//         setLoading(false);
//         toast.error("Failed to fetch products");
//       });
//   }, [vendorObjId, currentPage, itemsPerPage, filterValue]);

//   useEffect(() => {
//     fetchProductList();
//   }, [fetchProductList]);

//   const debounce = (func, delay) => {
//     let timeoutId;
//     return (...args) => {
//       clearTimeout(timeoutId);
//       timeoutId = setTimeout(() => func(...args), delay);
//     };
//   };
//   const fetchSearchResults = useCallback(
//     async (searchTerm, page = currentPage, limit = itemsPerPage) => {
//       if (!searchTerm || !vendorObjId) {
//         setData([]);
//         setPaginationData("");
//         return;
//       }

//       setLoading(true);
//       try {
//         const response = await axios.get(
//           `${apiurl}/admin/v1/product/search?vendorObjId=${vendorObjId}&search=${encodeURIComponent(
//             searchTerm
//           )}&page=${page}&limit=${limit}`,
//           { headers: { "Content-Type": "application/json" } }
//         );
//         if (response?.data?.products) {
//           setData(response.data.products);
//           setPaginationData(response.data.pagination || {});
//         } else {
//           setData([]);
//           setPaginationData("");
//         }
//       } catch (error) {
//         console.error("Error fetching search results:", error);
//         toast.error("Failed to fetch search results");
//         setData([]);
//         setPaginationData("");
//       } finally {
//         setLoading(false);
//       }
//     },
//     [vendorObjId, currentPage, itemsPerPage]
//   );

//   // Debounced search for typing
//   const debouncedSearch = useCallback(debounce(fetchSearchResults, 2000), [
//     fetchSearchResults,
//   ]);

//   // Handle barcode search input
//   const handleSearch = (event) => {
//     const value = event.target.value;
//     setInputValue(value);
//     setCurrentPage(1); // Reset to page 1 on new search
//     if (value) {
//       debouncedSearch(value, 1, itemsPerPage); // Use debounce for typing
//     } else {
//       setData([]);
//       setPaginationData("");
//       fetchProductList();
//     }
//   };

//   // Handle global search input
//   const handleGlobalSearch = (e) => {
//     const value = e.target.value;
//     setFilterValue(value);
//     setCurrentPage(1); // Reset to page 1 on new search
//     if (value) {
//       debouncedSearch(value, 1, itemsPerPage); // Use debounce for typing
//     } else {
//       setData([]);
//       setPaginationData("");
//       fetchProductList();
//     }
//   };

//   // Trigger immediate search on pagination changes (page or limit) when filterValue exists
//   useEffect(() => {
//     if (filterValue && filterValue.length >= 1) {
//       fetchSearchResults(filterValue, currentPage, itemsPerPage); // Immediate search for pagination
//     }
//   }, [currentPage, itemsPerPage, fetchSearchResults]); // Removed filterValue from dependencies
//   // Update combinedData
//   useEffect(() => {
//     const uniqueItems = [];
//     const itemIds = new Set();

//     selectedItems.forEach((item) => {
//       if (!itemIds.has(item._id)) {
//         uniqueItems.push(item);
//         itemIds.add(item._id);
//       }
//     });

//     searchData.forEach((item) => {
//       if (!itemIds.has(item._id)) {
//         uniqueItems.push(item);
//         itemIds.add(item._id);
//       }
//     });

//     setCombinedData(uniqueItems);
//   }, [selectedItems, searchData]);

//   // Handle checkbox change
//   const handleCheckboxChange = (itemId) => {
//     setCheckedItems((prev) =>
//       prev.includes(itemId)
//         ? prev.filter((id) => id !== itemId)
//         : [...prev, itemId]
//     );
//   };

//   useEffect(() => {
//     const jsonData = data.filter((product) =>
//       checkedItems.includes(product.id)
//     );
//     setSelectedItems(jsonData);
//   }, [data, checkedItems]);

//   // Handle size selection
//   const sizeHandle = (variantId) => {
//     const filteredData = data.flatMap((product) =>
//       product.variants
//         .filter((variant) => variant._id === variantId)
//         .map((variant) => ({
//           ...variant,
//           productId: product.id,
//           productObjId: product._id,
//           productImage: product.image,
//           title: product.title,
//         }))
//     );

//     setSearchData((prev) => {
//       const existingIds = new Set(prev.map((item) => item._id));
//       const newItems = filteredData.filter(
//         (item) => !existingIds.has(item._id)
//       );
//       return [...prev, ...newItems];
//     });
//   };

//   // Remove item from searchData
//   const removeHandle = (itemId) => {
//     setSearchData((prev) => prev.filter((item) => item._id !== itemId));
//   };

//   // Handle pagination
//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   // Customer input handler
//   const CustomerInputHandler = (e) => {
//     const { name, value } = e.target;
//     let validValue = value;

//     if (name === "customerPhone") {
//       let digitsOnly = value.replace(/[^0-9]/g, "");
//       if (digitsOnly.startsWith("91")) {
//         digitsOnly = digitsOnly.slice(2);
//       }
//       digitsOnly = digitsOnly.slice(0, 10);
//       validValue = "91" + digitsOnly;
//     }

//     setCustomerInformation((prev) => ({
//       ...prev,
//       [name]: validValue,
//     }));
//   };

//   // Update catalog status
//   const UpdateCatalogStatus = (status) => {
//     const products = combinedData.map((item) => ({
//       productObjId: item.productObjId || "",
//       productId: item.productId || "",
//       varientId: item.id || "",
//       varientObjId: item._id || "",
//       sku: item.sku || "",
//       barcode: item.barcode || "",
//     }));

//     if (userData) {
//       const tags = [choosedPdf];
//       const data = JSON.stringify({
//         vendorObjId,
//         ...(userData.type === "superadmin" && {
//           storeObjId: userData?.storeDetails?.storeObjId,
//         }),
//         userObjId: userData?._id,
//         actionDetails: {
//           products,
//           type: status,
//           description: "",
//           tags,
//         },
//         catalogDetails: { name: choosedPdf },
//         customerDetails: {
//           name: customerInformation.customerName || "",
//           phone: customerInformation.customerPhone || "",
//           customerEmail: customerInformation.customerEmail || "",
//         },
//       });

//       const config = {
//         method: "post",
//         maxBodyLength: Infinity,
//         url: `${apiurl}/admin/v1/analytic/create`,
//         headers: { "Content-Type": "application/json" },
//         data,
//       };

//       axios
//         .request(config)
//         .then((response) => {
//           console.log("Catalog status updated:", response.data);
//         })
//         .catch((error) => {
//           console.error("Error updating catalog status:", error);
//         });
//     }
//   };

//   // Email handler
//   const EmailSendHandler = async () => {
//     if (
//       !pdfFile ||
//       !customerInformation?.customerName ||
//       !customerInformation?.customerEmail
//     ) {
//       setError("Please fill in all required fields");
//       return;
//     }

//     try {
//       setSendingLoader(true);
//       const formData = new FormData();
//       formData.append("pdf", pdfFile);
//       formData.append("name", customerInformation.customerName);
//       formData.append("email", customerInformation.customerEmail);

//       const response = await axios.post(
//         `${apiurl}/admin/v1/marketing/EmailWithFileAttachment`,
//         formData,
//         { headers: { "Content-Type": "multipart/form-data" } }
//       );

//       if (response.data.success) {
//         setGeneratePdfPopup(false);
//         UpdateCatalogStatus("catalog_sent_email");
//       } else {
//         setError(response.data.message);
//       }
//     } catch (error) {
//       console.error("Error sending email:", error);
//       setError("Failed to send email. Please try again.");
//     } finally {
//       setSendingLoader(false);
//     }
//   };

//   // WhatsApp handler
//   const WhatsappSendHandler = async () => {
//     if (!customerInformation?.customerPhone || !pdfFile) {
//       setError("Phone number or PDF file is missing!");
//       return;
//     }

//     try {
//       setSendingLoader(true);
//       const fileUrl = await FileLinkHandler(pdfFile);
//       if (!fileUrl) {
//         setError("Failed to upload PDF.");
//         return;
//       }

//       const messageText = `Hi ${customerInformation.customerName}, please find the attached PDF here: ${fileUrl}`;
//       const whatsappUrl = `https://wa.me/${
//         customerInformation.customerPhone
//       }?text=${encodeURIComponent(messageText)}`;
//       window.open(whatsappUrl, "_blank");
//       UpdateCatalogStatus("catalog_sent_whatsapp");
//     } catch (error) {
//       console.error("Error sending WhatsApp message:", error);
//       setError("Failed to send the message.");
//     } finally {
//       setSendingLoader(false);
//     }
//   };

//   // File upload handler
//   const FileLinkHandler = async (file) => {
//     if (!file) return null;

//     const formData = new FormData();
//     formData.append("file", file);

//     try {
//       const response = await axios.post(
//         `${apiurl}/admin/v1/media/document`,
//         formData,
//         {
//           headers: { "Content-Type": "multipart/form-data" },
//           maxBodyLength: Infinity,
//         }
//       );

//       if (response.data.success) {
//         return response.data?.fileUrl;
//       }
//       return null;
//     } catch (error) {
//       console.error("Error uploading file:", error.message);
//       return null;
//     }
//   };

//   useEffect(() => {
//     if (error) {
//       setTimeout(() => setError(""), 5000);
//     }
//   }, [error]);

//   useEffect(() => {
//     if (userData?.storeDetails) {
//       setStoreManagerPhoneInput(userData?.phone || "");
//       setStoreManagerInput(userData?.name || "");
//     }
//   }, [userData]);

//   const sendStoreData = {
//     storename: userData?.storeDetails?.storeName || "",
//     managername: storeManagerInput || "",
//     storePhone: storeManagerPhoneInput || "",
//     storeAddress: userData?.storeDetails?.storeAddress || "",
//     storeCode: userData?.storeDetails?.storeCode || "N/A",
//   };

//   const clearCart = () => {
//     setSearchData([]);
//     setSelectedItems([]);
//     setCombinedData([]);
//     setCheckedItems([]);
//     localStorage.removeItem("selectedItems");
//     toast.success("Cart cleared successfully!");
//   };

//   return (
//     <Layout>
//       <Container>
//         {sendingLoader && <InfiLoader />}
//         {isOpenBarCode && (
//           <div className="backdrop-blur-md bg-black/60 h-full w-full fixed top-0 left-0 right-0 bottom-0 z-20 flex justify-center items-center">
//             <button
//               style={{ borderWidth: "1px" }}
//               className="absolute top-4 right-4 p-1 border-white rounded-md text-white"
//               onClick={() => setIsOpenBarCode(false)}
//             >
//               <RiCloseLargeFill />
//             </button>
//             <div className="mt-[10%] md:mt-0 m-5 rounded-lg overflow-hidden p-4 relative shadow-lg">
//               <BarcodeScanner
//                 barCodeResult={barCodeResult}
//                 setBarCodeResult={setBarCodeResult}
//                 barcodeData={barcodeData}
//                 setBarCodeData={setBarCodeData}
//                 combinedData={combinedData}
//                 setCombinedData={setCombinedData}
//               />
//             </div>
//             {isBarCodeProductList && (
//               <div className="absolute h-[80vh] bg-white rounded-xl w-10/12 p-5 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
//                 {barcodeData?.map((item, index) => (
//                   <div key={index}>{item.title}</div>
//                 ))}
//               </div>
//             )}
//             <div
//               className={`absolute bottom-5 w-full flex items-center gap-2 px-3 ${
//                 barCodeResult ? "justify-center" : "justify-end"
//               }`}
//             >
//               {barCodeResult && (
//                 <div className="bg-white w-11/12 p-2 py-3 rounded-lg">
//                   {barCodeResult} added successfully
//                 </div>
//               )}
//               <button
//                 className="bg-blue-500 text-white p-3 rounded-full text-4xl"
//                 onClick={() => setIsBarCodeProductList(!isBarCodeProductList)}
//               >
//                 {isBarCodeProductList ? (
//                   <IoCloseOutline />
//                 ) : (
//                   <IoBarcodeOutline />
//                 )}
//               </button>
//               <button
//                 className="bg-black text-white p-3 rounded-full text-xl"
//                 onClick={() => setViewLive(!viewLive)}
//               >
//                 <RiShoppingCartLine />
//               </button>
//             </div>
//           </div>
//         )}
//         <ToastContainer />
//         <div className="bg-white h-full overflow-auto">
//           {loading ? (
//             <InfiLoader />
//           ) : (
//             <div className="h-full overflow-auto">
//               <div className="sticky top-0 z-20 bg-black/10 px-1.5 lg:px-4 py-2 grid grid-cols-2 md:flex items-center justify-between gap-2 rounded-lg shadow-md flex-wrap md:flex-nowrap">
//                 <button
//                   className="bg-black px-2 text-white rounded-full lg:hidden text-2xl w-10 flex justify-center items-center lg:w-auto"
//                   onClick={() => setIsOpenBarCode(true)}
//                 >
//                   <IoBarcodeOutline />
//                 </button>
//                 <form
//                   onSubmit={(e) => e.preventDefault()}
//                   className="hidden md:flex items-center gap-2"
//                 >
//                   <Input.Normal
//                     className="lg:text-[0.875rem] text-xs py-1"
//                     placeholder="Scan Barcode..."
//                     onChange={handleSearch}
//                     value={inputValue}
//                     ref={inputRef}
//                   />
//                   <div className="relative group">
//                     <AiFillInfoCircle className="text-gray-400 hover:text-gray-600 transition-colors cursor-pointer" />
//                     <div className="absolute hidden group-hover:flex w-max bg-white text-gray-800 text-xs rounded-md py-2 px-3 left-1/2 -translate-x-1/2 top-full mt-2 shadow-lg border border-gray-300 opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10">
//                       <span className="block capitalize">
//                         Focus this input for machine scanning
//                       </span>
//                       <span className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3 h-3 bg-white border-l border-t border-gray-300 rotate-45"></span>
//                     </div>
//                   </div>
//                 </form>
//                 <div className="w-full col-span-2 md:w-1/2 relative group">
//                   <Input.Normal
//                     type="text"
//                     placeholder="Global Search..."
//                     className="lg:text-[0.875rem] text-xs py-1.5 lg:w-full hover:border-gray-500 transition duration-200"
//                     value={filterValue}
//                     onChange={handleGlobalSearch}
//                     ref={searchInputRef}
//                     autoFocus
//                   />
//                   <BiSearch className="text-lg absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 group-hover:text-black transition duration-200" />
//                 </div>
//                 <div className="flex row-start-1 col-start-2 items-center justify-end gap-2 border-l lg:border-none lg:gap-3">
//                   <div className="relative">
//                     <button
//                       className="p-1.5 flex justify-center items-center text-lg hover:bg-black hover:text-white rounded-full transition"
//                       onClick={() => setViewLive(true)}
//                     >
//                       <RiShoppingCartLine />
//                     </button>
//                     <div className="bg-black text-white text-[0.625rem] w-4 h-4 rounded-full absolute -right-1 -top-1 flex justify-center items-center">
//                       {combinedData.length}
//                     </div>
//                   </div>
//                   {userData?.storeDetails?.storeObjId ? (
//                     <button
//                       className={`w-full text-[0.75rem] lg:text-[0.875rem] lg:p-1.5 lg:px-3 p-1 px-4 rounded ${
//                         combinedData.length === 0
//                           ? "bg-gray-300 text-gray-500 cursor-not-allowed"
//                           : "bg-black text-white hover:bg-gray-800"
//                       }`}
//                       disabled={combinedData.length === 0}
//                       onClick={() => {
//                         setGeneratePdfPopup(true);
//                         UpdateCatalogStatus("catalog_generated");
//                       }}
//                     >
//                       Generate
//                     </button>
//                   ) : (
//                     <button
//                       className="w-full text-[0.75rem] lg:text-[0.875rem] lg:p-1.5 lg:px-3 p-1 px-4 rounded bg-gray-300 text-gray-500 cursor-not-allowed"
//                       disabled
//                       onClick={() => toast.error("No store assigned.")}
//                     >
//                       Generate
//                     </button>
//                   )}
//                 </div>
//               </div>
//               <div className="h-full w-full">
//                 <div className="productSection w-full">
//                   <div className="h-full w-full mt-3 md:mt-5">
//                     {data.length === 0 && !loading ? (
//                       <div className="text-center p-4 text-gray-600">
//                         No products found.
//                       </div>
//                     ) : (
//                       <>
//                         <div className="flex md:hidden flex-col gap-2">
//                           {data?.map((item, index) => (
//                             <div
//                               key={item.id}
//                               className="flex items-start gap-1"
//                             >
//                               <label className="p-1 px-2 rounded-sm bg-gray-50 font-medium text-xs">
//                                 {index + 1}
//                               </label>
//                               <div className="flex justify-center items-center w-full">
//                                 <img
//                                   className="max-h-24 max-w-24 w-2/5 rounded object-cover"
//                                   src={item?.image || "/imageNotFound.png"}
//                                   alt={item?.title}
//                                 />
//                                 <div className="p-2 flex-1">
//                                   <div className="text-sm truncate">
//                                     {item?.title}
//                                   </div>
//                                   <div className="text-xs mt-2 bg-gray-50 p-2 rounded">
//                                     <label className="font-medium">Size</label>
//                                     <div className="text-xs mt-1">
//                                       <VariantSku
//                                         item={item}
//                                         sizeHandle={sizeHandle}
//                                         padding="px-2 p-1"
//                                       />
//                                     </div>
//                                   </div>
//                                 </div>
//                               </div>
//                             </div>
//                           ))}
//                         </div>
//                         <div className="md:block hidden relative w-full h-full overflow-y-auto shadow-md sm:rounded-lg">
//                           <table className="w-full text-sm text-left rtl:text-right text-gray-500">
//                             <thead className="text-xs text-gray-700 uppercase bg-gray-50">
//                               <tr>
//                                 <th scope="col" className="px-6 py-3">
//                                   #
//                                 </th>
//                                 <th scope="col" className="px-6 py-3">
//                                   Image
//                                 </th>
//                                 <th scope="col" className="px-6 py-3">
//                                   Title
//                                 </th>
//                                 <th scope="col" className="px-6 py-3">
//                                   Add by Size
//                                 </th>
//                                 {/* <th scope="col" className="px-6 py-3">
//                                   <select
//                                     value={itemsPerPage}
//                                     className="text-xs rounded text-black border px-2 py-1"
//                                     onChange={(e) => {
//                                       setItemsPerPage(e.target.value);
//                                       setCurrentPage(1); // Reset to page 1
//                                     }}
//                                   >
//                                     <option value="100">100</option>
//                                     <option value="250">250</option>
//                                     <option value="500">500</option>
//                                     <option value="1000">1000</option>
//                                   </select>
//                                 </th> */}
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {data?.map((item, index) => (
//                                 <tr
//                                   key={item.id}
//                                   className="border-b hover:bg-gray-50"
//                                 >
//                                   <th
//                                     scope="row"
//                                     className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap"
//                                   >
//                                     {index + 1}
//                                   </th>
//                                   <td className="px-6 py-4">
//                                     <label
//                                       htmlFor={`${item.id}`}
//                                       className="cursor-pointer"
//                                     >
//                                       <img
//                                         src={item.image || "/imageNotFound.png"}
//                                         alt={item.title}
//                                         className="w-24 rounded object-cover"
//                                       />
//                                     </label>
//                                   </td>
//                                   <td className="px-6 py-4">
//                                     <label className="cursor-pointer">
//                                       {item?.title}
//                                     </label>
//                                   </td>
//                                   <td className="px-6 py-4">
//                                     <VariantSku
//                                       item={item}
//                                       sizeHandle={sizeHandle}
//                                     />
//                                   </td>
//                                   <td></td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                         </div>
//                       </>
//                     )}
//                   </div>
//                   {paginationData && (
//                     <div className="flex justify-center m-1 sticky bottom-0 backdrop-blur-md bg-white/90">
//                       <Pagination
//                         currentPage={currentPage}
//                         totalItems={paginationData?.totalItems || 0}
//                         itemsPerPage={parseInt(itemsPerPage)}
//                         onPageChange={handlePageChange}
//                       />
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//         <div
//           className={`fixed z-50 bg-white lg:w-1/4 w-11/12 h-[95%] lg:h-screen p-4 lg:p-6 transition-all duration-500 ease-in-out
//           ${
//             viewLive
//               ? "opacity-100 translate-x-0 translate-y-0"
//               : "opacity-0 lg:-translate-x-full translate-y-full pointer-events-none"
//           }
//           lg:left-0 lg:top-0 lg:rounded-r-3xl lg:drop-shadow-xl bottom-0 left-1/2 -translate-x-1/2 rounded-t-lg shadow-xl`}
//         >
//           <div className="flex justify-between items-center">
//             <p className="flex items-center gap-2">
//               <span className="text-xl font-semibold">Cart</span>
//               <span className="bg-blue-100 border border-blue-300 text-blue-600 px-2 rounded text-xs">
//                 {combinedData.length}
//               </span>
//             </p>
//             <div className="flex items-center gap-3">
//               {combinedData.length > 0 && (
//                 <button
//                   className="text-gray-500 hover:text-red-500 transition flex items-center gap-1 text-sm"
//                   onClick={clearCart}
//                   aria-label="Clear cart"
//                 >
//                   <FaTrash className="w-4 h-4" />
//                   Clear
//                 </button>
//               )}
//               <button
//                 className="text-gray-400 hover:text-black transition"
//                 onClick={() => setViewLive(false)}
//               >
//                 <RiCloseLargeFill />
//               </button>
//             </div>
//           </div>
//           {combinedData.length > 0 ? (
//             <div className="flex flex-col gap-4 my-4 overflow-scroll h-full">
//               {combinedData.map((item) => (
//                 <div
//                   className="border-b flex gap-4 py-4"
//                   key={item._id}
//                   id={item._id}
//                 >
//                   <div>
//                     <img
//                       src={item.productImage || "/imageNotFound.png"}
//                       alt={item.title}
//                       className="rounded w-20 h-20 object-cover"
//                     />
//                   </div>
//                   <div className="flex justify-between w-full">
//                     <div className="flex flex-col gap-1 items-start">
//                       <div className="flex flex-col items-start">
//                         <p className="text-xs bg-gray-50 px-2 py-0.5 rounded text-gray-500">
//                           <i>{item.barcode}</i>
//                         </p>
//                         <label className="text-sm font-semibold">
//                           {item.title}
//                         </label>
//                       </div>
//                       <p className="border p-1 px-2 rounded text-xs text-gray-600">
//                         {item.size}
//                       </p>
//                     </div>
//                     <div className="flex items-start">
//                       <button
//                         className="text-gray-500 hover:text-red-500"
//                         onClick={() => removeHandle(item._id)}
//                         aria-label="Remove item"
//                       >
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           viewBox="0 0 24 24"
//                           fill="none"
//                           stroke="currentColor"
//                           strokeWidth="2"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           className="w-5 h-5"
//                         >
//                           <path d="M3 6h18"></path>
//                           <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
//                           <path d="M6 6v14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6"></path>
//                           <path d="M9 11v6"></path>
//                           <path d="M15 11v6"></path>
//                         </svg>
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           ) : (
//             <div className="w-full h-full flex justify-center items-center">
//               <div className="bg-gray-50 text-gray-600 rounded-md border border-gray-300 p-6">
//                 <h2 className="text-sm">Cart is empty!</h2>
//               </div>
//             </div>
//           )}
//         </div>
//         {generatePdfPopup && (
//           <Card.AddPopUp
//             removePopUp={() => setGeneratePdfPopup(false)}
//             className="transition-all duration-500"
//             height="auto"
//           >
//             <div className="p-4 py-2 rounded text-xs md:text-sm">
//               <div className="flex justify-between items-start sticky top-0 bg-white">
//                 <div className="flex flex-col text-gray-800">
//                   <div className="font-semibold md:font-bold text-lg md:text-xl capitalize">
//                     {userData?.storeDetails?.storeName || "Store Name"}
//                   </div>
//                 </div>
//               </div>
//               <div className="mb-4 gap-2 md:gap-4 shadow border rounded-md p-3 mt-4">
//                 <p className="font-semibold text-lg">Store Information</p>
//                 <div className="p-3 text-gray-600 flex flex-col gap-2">
//                   <div className="grid grid-cols-2 gap-2">
//                     <p className="flex items-center gap-2 font-semibold">
//                       <MdOutlinePerson className="text-lg" />
//                       Manager Name
//                     </p>
//                     <p>{storeManagerInput || "N/A"}</p>
//                   </div>
//                   <div className="grid grid-cols-2 gap-2">
//                     <p className="flex items-center gap-2 font-semibold">
//                       <MdOutlinePhone className="text-lg" />
//                       Phone
//                     </p>
//                     <p>{storeManagerPhoneInput || "N/A"}</p>
//                   </div>
//                 </div>
//               </div>
//               <div className="my-4 bg-white">
//                 <div className="flex flex-col md:flex-row md:items-center justify-between gap-2">
//                   <label className="inline-flex items-center cursor-pointer">
//                     <input
//                       type="checkbox"
//                       className="sr-only peer"
//                       checked={isPersonalize}
//                       onChange={(e) => setIsPersonalize(e.target.checked)}
//                     />
//                     <div className="relative w-9 h-5 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-600"></div>
//                     <span className="ml-3 text-sm font-medium text-gray-900">
//                       Personalize
//                     </span>
//                   </label>
//                   <div className="text-xs md:text-sm px-3 py-1 rounded bg-blue-50 border border-blue-400 text-blue-700">
//                     Customer Information
//                   </div>
//                 </div>
//                 {isPersonalize && (
//                   <div className="flex flex-col gap-2 my-3 transition-all duration-500">
//                     <div className="flex md:flex-row flex-col gap-2 md:gap-4">
//                       <Input.Normal
//                         label="Customer Name"
//                         type="text"
//                         name="customerName"
//                         placeholder="Name"
//                         value={customerInformation?.customerName || ""}
//                         onChange={CustomerInputHandler}
//                       />
//                       <Input.Normal
//                         label="Phone Number"
//                         type="text"
//                         name="customerPhone"
//                         placeholder="Phone Number"
//                         value={customerInformation?.customerPhone || ""}
//                         onChange={CustomerInputHandler}
//                       />
//                     </div>
//                     <Input.Normal
//                       label="Email"
//                       type="email"
//                       name="customerEmail"
//                       placeholder="Email"
//                       value={customerInformation?.customerEmail || ""}
//                       onChange={CustomerInputHandler}
//                     />
//                   </div>
//                 )}
//               </div>
//               <div className="bg-gray-50 border rounded-md p-3">
//                 <Input.Normal
//                   label="Choose PDF Template"
//                   isInput={false}
//                   labelClassName="mt-2 p-0"
//                 />
//                 <div className="flex justify-evenly gap-5 md:mt-1">
//                   <AllPdfs
//                     data={{ Product: combinedData, Store: sendStoreData }}
//                   />
//                 </div>
//               </div>
//               <div className="flex justify-between items-center gap-3 mt-3">
//                 {isPersonalize && (
//                   <div className="flex items-center gap-2 mt-3 capitalize">
//                     <button
//                       className="px-3 py-1 border rounded-md flex items-center gap-2 hover:text-red-700 text-nowrap"
//                       onClick={EmailSendHandler}
//                     >
//                       <svg.gmail className="cursor-pointer" />
//                       {sending === true ? (
//                         <loader.staggerCircle color="#fd1f1a" />
//                       ) : null}
//                     </button>
//                     <button
//                       className="px-3 py-1.5 border rounded-md flex cursor-pointer items-center gap-2 hover:text-green-700 text-nowrap w-14"
//                       onClick={WhatsappSendHandler}
//                     >
//                       <img src="/whatsappShare.png" className="w-8 h-auto" />
//                     </button>
//                   </div>
//                 )}
//                 <PDFComponent
//                   data={{
//                     Product: combinedData,
//                     Store: sendStoreData,
//                     Customer: customerInformation,
//                   }}
//                   submitData={UpdateCatalogStatus}
//                   setPdfFile={setPdfFile}
//                   pdfFile={pdfFile}
//                 />
//               </div>
//               {error && <Error err={error} absolute className="mt-2" />}
//             </div>
//           </Card.AddPopUp>
//         )}
//       </Container>
//     </Layout>
//   );
// };

// export const VariantSku = ({ item, sizeHandle, padding, margin }) => {
//   return (
//     <label
//       htmlFor={`${item.id}`}
//       className="cursor-pointer flex flex-wrap gap-2"
//     >
//       {item?.variants?.map((variant) => (
//         <button
//           className={`bg-transparent border text-gray-600 rounded hover:bg-blue-50 hover:border-blue-300 transition ${
//             padding || "p-1.5 px-3"
//           } ${margin || "m-1"} text-xs`}
//           onClick={() => sizeHandle(variant._id)}
//           key={variant._id}
//         >
//           {variant.size}
//         </button>
//       ))}
//     </label>
//   );
// };

// export default CreateCatalog;

// import React, {
//   useState,
//   useEffect,
//   useCallback,
//   useRef,
//   useContext,
// } from "react";
// import axios from "axios";
// import "./createCatalog.css";
// import "react-toastify/dist/ReactToastify.css";
// import PDFComponent from "./PDFComponent";
// import Layout, { Container } from "../../components/layout";
// import { ToastContainer, toast } from "react-toastify";
// import { RiCloseLargeFill, RiShoppingCartLine } from "react-icons/ri";
// import { BiSearch } from "react-icons/bi";
// import BarcodeScanner from "./barcode";
// import { IoBarcodeOutline, IoCloseOutline } from "react-icons/io5";
// import { AiFillInfoCircle } from "react-icons/ai";
// import { InfiLoader } from "../../components/loader";
// import { apiurl } from "../../config/config";
// import Card from "../../components/card";
// import Input from "../../components/inputContainer";
// import { PdfContext } from "./pdfContext";
// import Error from "../../components/error";
// import { MdOutlinePerson, MdOutlinePhone } from "react-icons/md";
// import Pagination from "../../components/pagination";
// import AllPdfs from "./allPdfs";
// import { useUser } from "../../config/userProvider";
// import { FaTrash } from "react-icons/fa6";
// import svg from "../../components/svg";
// import loader from "../../components/loader";

// const CreateCatalog = () => {
//   const { userData } = useUser();
//   const { choosedPdf } = useContext(PdfContext);
//   const vendorObjId = userData?.vendorDetails?.vendorObjId;

//   /* --------------------------------------------------------------
//      STATE
//   -------------------------------------------------------------- */
//   const [inputValue, setInputValue] = useState("");
//   const [data, setData] = useState([]);
//   const [checkedItems, setCheckedItems] = useState([]);
//   const [selectedItems, setSelectedItems] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [sendingLoader, setSendingLoader] = useState(false);
//   const [searchData, setSearchData] = useState([]);
//   const [combinedData, setCombinedData] = useState([]);
//   const [viewLive, setViewLive] = useState(false);
//   const [generatePdfPopup, setGeneratePdfPopup] = useState(false);
//   const [filterValue, setFilterValue] = useState("");
//   const [storeManagerPhoneInput, setStoreManagerPhoneInput] = useState("");
//   const [storeManagerInput, setStoreManagerInput] = useState("");
//   const [itemsPerPage, setItemsPerPage] = useState(100);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [paginationData, setPaginationData] = useState("");
//   const [pdfFile, setPdfFile] = useState();
//   const [isOpenBarCode, setIsOpenBarCode] = useState(false);
//   const [barCodeResult, setBarCodeResult] = useState("");
//   const [barcodeData, setBarCodeData] = useState([]);
//   const [isBarCodeProductList, setIsBarCodeProductList] = useState(false);
//   const { isPersonalize, setIsPersonalize } = useUser();
//   const [error, setError] = useState("");
//   const [customerInformation, setCustomerInformation] = useState({});
//   const inputRef = useRef(null);
//   const searchInputRef = useRef(null);
//   const [sending, setSending] = useState(false);

//   /* --------------------------------------------------------------
//      **FIXED DEBOUNCE REFS** - Created ONCE, never recreated
//   -------------------------------------------------------------- */
//   const barcodeTimeoutRef = useRef(null);
//   const textTimeoutRef = useRef(null);

//   /* --------------------------------------------------------------
//      LOCAL STORAGE
//   -------------------------------------------------------------- */
//   useEffect(() => {
//     const saved = localStorage.getItem("selectedItems");
//     if (saved) setSearchData(JSON.parse(saved));
//   }, []);

//   useEffect(() => {
//     localStorage.setItem("selectedItems", JSON.stringify(searchData));
//   }, [searchData]);

//   /* --------------------------------------------------------------
//      FOCUS: Only global search on mount
//   -------------------------------------------------------------- */
//   useEffect(() => {
//     searchInputRef.current?.focus();
//   }, []);

//   /* --------------------------------------------------------------
//      FETCH PRODUCT LIST
//   -------------------------------------------------------------- */
//   const fetchProductList = useCallback(() => {
//     if (!vendorObjId || filterValue || inputValue) return;
//     setLoading(true);
//     const payload = JSON.stringify({
//       vendorObjId,
//       page: currentPage,
//       limit: parseInt(itemsPerPage),
//     });

//     const config = {
//       method: "post",
//       url: `${apiurl}/admin/v1/product/get/catalog`,
//       headers: { "Content-Type": "application/json" },
//       data: payload,
//     };

//     axios
//       .request(config)
//       .then((res) => {
//         if (res?.data?.products) {
//           setData(res.data.products);
//           setPaginationData(res.data.pagination);
//         }
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error(err);
//         toast.error("Failed to fetch products");
//         setLoading(false);
//       });
//   }, [vendorObjId, currentPage, itemsPerPage, filterValue, inputValue]);

//   useEffect(() => {
//     fetchProductList();
//   }, [fetchProductList]);

//   /* --------------------------------------------------------------
//      SEARCH API – BARCODE OR TEXT MODE
//   -------------------------------------------------------------- */
//   const fetchSearchResults = useCallback(
//     async (term, page = currentPage, limit = itemsPerPage, isBarcode = false) => {
//       if (!term || !vendorObjId) {
//         setData([]);
//         setPaginationData("");
//         return;
//       }

//       setLoading(true);
//       try {
//         // const paramKey = isBarcode ? "barcode" : "search";
//         const paramKey = isBarcode ? "sku" : "search";
//         const url = `${apiurl}/admin/v1/product/search?vendorObjId=${vendorObjId}&${paramKey}=${encodeURIComponent(
//           term
//         )}&page=${page}&limit=${limit}`;

//         const res = await axios.get(url, {
//           headers: { "Content-Type": "application/json" },
//         });

//         if (res?.data?.products) {
//           setData(res.data.products);
//           setPaginationData(res.data.pagination || {});
//         } else {
//           setData([]);
//           setPaginationData("");
//         }
//       } catch (err) {
//         console.error(err);
//         toast.error("Failed to fetch search results");
//         setData([]);
//         setPaginationData("");
//       } finally {
//         setLoading(false);
//       }
//     },
//     [vendorObjId, currentPage, itemsPerPage]
//   );

//   /* --------------------------------------------------------------
//      **FIXED DEBOUNCE FUNCTIONS** - 3 SECONDS AFTER STOP TYPING
//   -------------------------------------------------------------- */
//   const debouncedBarcodeSearch = useCallback((term) => {
//     // **CLEAR PREVIOUS TIMEOUT**
//     if (barcodeTimeoutRef.current) {
//       clearTimeout(barcodeTimeoutRef.current);
//     }

//     // **SET NEW 3-SECOND TIMEOUT**
//     barcodeTimeoutRef.current = setTimeout(() => {
//       fetchSearchResults(term, 1, itemsPerPage, true);
//     }, 3000);
//   }, [fetchSearchResults, itemsPerPage]);

//   const debouncedTextSearch = useCallback((term) => {
//     // **CLEAR PREVIOUS TIMEOUT**
//     if (textTimeoutRef.current) {
//       clearTimeout(textTimeoutRef.current);
//     }

//     // **SET NEW 3-SECOND TIMEOUT**
//     textTimeoutRef.current = setTimeout(() => {
//       fetchSearchResults(term, 1, itemsPerPage, false);
//     }, 3000);
//   }, [fetchSearchResults, itemsPerPage]);

//   /* --------------------------------------------------------------
//      **INPUT HANDLERS** - Call debounce on EVERY keystroke
//   -------------------------------------------------------------- */
//   const handleBarcodeSearch = (e) => {
//     const val = e.target.value;
//     setInputValue(val);
//     setCurrentPage(1);

//     if (val) {
//       // **EVERY KEYSTROKE restarts 3-second timer**
//       debouncedBarcodeSearch(val);
//     } else {
//       if (barcodeTimeoutRef.current) clearTimeout(barcodeTimeoutRef.current);
//       setData([]);
//       setPaginationData("");
//       fetchProductList();
//     }
//   };

//   const handleGlobalSearch = (e) => {
//     const val = e.target.value;
//     setFilterValue(val);
//     setCurrentPage(1);

//     if (val) {
//       // **EVERY KEYSTROKE restarts 3-second timer**
//       debouncedTextSearch(val);
//     } else {
//       if (textTimeoutRef.current) clearTimeout(textTimeoutRef.current);
//       setData([]);
//       setPaginationData("");
//       fetchProductList();
//     }
//   };

//   // **IMMEDIATE SEARCH ON ENTER**
//   const handleKeyPress = (e, isBarcode = false) => {
//     if (e.key === "Enter") {
//       const term = isBarcode ? inputValue : filterValue;
//       if (term) {
//         // **CLEAR TIMEOUT + IMMEDIATE SEARCH**
//         if (isBarcode && barcodeTimeoutRef.current) clearTimeout(barcodeTimeoutRef.current);
//         if (!isBarcode && textTimeoutRef.current) clearTimeout(textTimeoutRef.current);
//         fetchSearchResults(term, 1, itemsPerPage, isBarcode);
//       }
//     }
//   };

//   /* --------------------------------------------------------------
//      PAGINATION
//   -------------------------------------------------------------- */
//   useEffect(() => {
//     if (filterValue) {
//       debouncedTextSearch(filterValue);
//     } else if (inputValue) {
//       debouncedBarcodeSearch(inputValue);
//     }
//   }, [currentPage, itemsPerPage, filterValue, inputValue, debouncedTextSearch, debouncedBarcodeSearch]);

//   /* --------------------------------------------------------------
//      BARCODE SCANNER - Also 3 seconds
//   -------------------------------------------------------------- */
//   const handleBarcodeDetected = useCallback((code) => {
//     setBarCodeResult(code);
//     setInputValue(code);
//     debouncedBarcodeSearch(code);
//   }, [debouncedBarcodeSearch]);

//   /* --------------------------------------------------------------
//      CLEANUP TIMEOUTS ON UNMOUNT
//   -------------------------------------------------------------- */
//   useEffect(() => {
//     return () => {
//       if (barcodeTimeoutRef.current) clearTimeout(barcodeTimeoutRef.current);
//       if (textTimeoutRef.current) clearTimeout(textTimeoutRef.current);
//     };
//   }, []);

//   /* --------------------------------------------------------------
//      REST OF CODE (unchanged - cart, PDF, etc.)
//   -------------------------------------------------------------- */
//   useEffect(() => {
//     const uniq = [];
//     const ids = new Set();
//     [...selectedItems, ...searchData].forEach((i) => {
//       if (!ids.has(i._id)) {
//         uniq.push(i);
//         ids.add(i._id);
//       }
//     });
//     setCombinedData(uniq);
//   }, [selectedItems, searchData]);

//   const handleCheckboxChange = (id) => {
//     setCheckedItems((prev) =>
//       prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
//     );
//   };

//   useEffect(() => {
//     const json = data.filter((p) => checkedItems.includes(p.id));
//     setSelectedItems(json);
//   }, [data, checkedItems]);

//   const sizeHandle = (variantId) => {
//     const filtered = data
//       .flatMap((p) =>
//         p.variants
//           .filter((v) => v._id === variantId)
//           .map((v) => ({
//             ...v,
//             productId: p.id,
//             productObjId: p._id,
//             productImage: p.image,
//             title: p.title,
//           }))
//       );

//     setSearchData((prev) => {
//       const existing = new Set(prev.map((i) => i._id));
//       const added = filtered.filter((i) => !existing.has(i._id));
//       return [...prev, ...added];
//     });
//   };

//   const removeHandle = (id) => {
//     setSearchData((prev) => prev.filter((i) => i._id !== id));
//   };

//   const handlePageChange = (page) => setCurrentPage(page);

//   const CustomerInputHandler = (e) => {
//     const { name, value } = e.target;
//     let v = value;
//     if (name === "customerPhone") {
//       let digits = value.replace(/[^0-9]/g, "");
//       if (digits.startsWith("91")) digits = digits.slice(2);
//       digits = digits.slice(0, 10);
//       v = "91" + digits;
//     }
//     setCustomerInformation((prev) => ({ ...prev, [name]: v }));
//   };

//   const UpdateCatalogStatus = (status) => {
//     const products = combinedData.map((i) => ({
//       productObjId: i.productObjId || "",
//       productId: i.productId || "",
//       varientId: i.id || "",
//       varientObjId: i._id || "",
//       sku: i.sku || "",
//       barcode: i.barcode || "",
//     }));

//     if (!userData) return;

//     const tags = [choosedPdf];
//     const payload = JSON.stringify({
//       vendorObjId,
//       ...(userData.type === "superadmin" && {
//         storeObjId: userData?.storeDetails?.storeObjId,
//       }),
//       userObjId: userData?._id,
//       actionDetails: { products, type: status, description: "", tags },
//       catalogDetails: { name: choosedPdf },
//       customerDetails: {
//         name: customerInformation.customerName || "",
//         phone: customerInformation.customerPhone || "",
//         customerEmail: customerInformation.customerEmail || "",
//       },
//     });

//     const cfg = {
//       method: "post",
//       url: `${apiurl}/admin/v1/analytic/create`,
//       headers: { "Content-Type": "application/json" },
//       data: payload,
//     };

//     axios.request(cfg).catch(console.error);
//   };

//   const EmailSendHandler = async () => {
//     if (!pdfFile || !customerInformation?.customerName || !customerInformation?.customerEmail) {
//       setError("Please fill in all required fields");
//       return;
//     }
//     setSendingLoader(true);
//     try {
//       const fd = new FormData();
//       fd.append("pdf", pdfFile);
//       fd.append("name", customerInformation.customerName);
//       fd.append("email", customerInformation.customerEmail);

//       const res = await axios.post(
//         `${apiurl}/admin/v1/marketing/EmailWithFileAttachment`,
//         fd,
//         { headers: { "Content-Type": "multipart/form-data" } }
//       );

//       if (res.data.success) {
//         setGeneratePdfPopup(false);
//         UpdateCatalogStatus("catalog_sent_email");
//       } else setError(res.data.message);
//     } catch (e) {
//       setError("Failed to send email.");
//     } finally {
//       setSendingLoader(false);
//     }
//   };

//   const WhatsappSendHandler = async () => {
//     if (!customerInformation?.customerPhone || !pdfFile) {
//       setError("Phone number or PDF file is missing!");
//       return;
//     }
//     setSendingLoader(true);
//     try {
//       const fileUrl = await FileLinkHandler(pdfFile);
//       if (!fileUrl) throw new Error("Upload failed");

//       const msg = `Hi ${customerInformation.customerName}, please find the attached PDF here: ${fileUrl}`;
//       const wa = `https://wa.me/${customerInformation.customerPhone}?text=${encodeURIComponent(
//         msg
//       )}`;
//       window.open(wa, "_blank");
//       UpdateCatalogStatus("catalog_sent_whatsapp");
//     } catch (e) {
//       setError("Failed to send WhatsApp.");
//     } finally {
//       setSendingLoader(false);
//     }
//   };

//   const FileLinkHandler = async (file) => {
//     if (!file) return null;
//     const fd = new FormData();
//     fd.append("file", file);
//     try {
//       const res = await axios.post(`${apiurl}/admin/v1/media/document`, fd, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });
//       return res.data.success ? res.data.fileUrl : null;
//     } catch {
//       return null;
//     }
//   };

//   useEffect(() => {
//     if (error) setTimeout(() => setError(""), 5000);
//   }, [error]);

//   useEffect(() => {
//     if (userData?.storeDetails) {
//       setStoreManagerPhoneInput(userData?.phone || "");
//       setStoreManagerInput(userData?.name || "");
//     }
//   }, [userData]);

//   const sendStoreData = {
//     storename: userData?.storeDetails?.storeName || "",
//     managername: storeManagerInput || "",
//     storePhone: storeManagerPhoneInput || "",
//     storeAddress: userData?.storeDetails?.storeAddress || "",
//     storeCode: userData?.storeDetails?.storeCode || "N/A",
//   };

//   const clearCart = () => {
//     setSearchData([]);
//     setSelectedItems([]);
//     setCombinedData([]);
//     setCheckedItems([]);
//     localStorage.removeItem("selectedItems");
//     toast.success("Cart cleared!");
//   };

//   /* --------------------------------------------------------------
//      RENDER
//   -------------------------------------------------------------- */
//   return (
//     <Layout>
//       <Container>
//         {sendingLoader && <InfiLoader />}

//         {/* BARCODE SCANNER POPUP */}
//         {isOpenBarCode && (
//           <div className="backdrop-blur-md bg-black/60 fixed inset-0 z-20 flex items-center justify-center">
//             <button
//               className="absolute top-4 right-4 p-1 border border-white rounded-md text-white"
//               onClick={() => setIsOpenBarCode(false)}
//             >
//               <RiCloseLargeFill />
//             </button>
//             <div className="mt-[10%] md:mt-0 m-5 rounded-lg overflow-hidden p-4 relative shadow-lg">
//               <BarcodeScanner
//                 barCodeResult={barCodeResult}
//                 setBarCodeResult={setBarCodeResult}
//                 barcodeData={barcodeData}
//                 setBarCodeData={setBarCodeData}
//                 combinedData={combinedData}
//                 setCombinedData={setCombinedData}
//                 onBarcodeDetected={handleBarcodeDetected}
//               />
//             </div>

//             {isBarCodeProductList && (
//               <div className="absolute inset-0 flex items-center justify-center">
//                 <div className="bg-white rounded-xl w-10/12 max-h-[80vh] overflow-auto p-5">
//                   {barcodeData?.map((it, idx) => (
//                     <div key={idx} className="border-b py-2">{it.title}</div>
//                   ))}
//                 </div>
//               </div>
//             )}

//             <div className="absolute bottom-5 w-full flex items-center gap-2 px-3">
//               {barCodeResult && (
//                 <div className="bg-white w-11/12 p-2 py-3 rounded-lg text-center">
//                   {barCodeResult} - Search in 3s ⏳
//                 </div>
//               )}
//               <button
//                 className="bg-blue-500 text-white p-3 rounded-full text-4xl"
//                 onClick={() => setIsBarCodeProductList(!isBarCodeProductList)}
//               >
//                 {isBarCodeProductList ? <IoCloseOutline /> : <IoBarcodeOutline />}
//               </button>
//               <button
//                 className="bg-black text-white p-3 rounded-full text-xl"
//                 onClick={() => setViewLive(!viewLive)}
//               >
//                 <RiShoppingCartLine />
//               </button>
//             </div>
//           </div>
//         )}

//         <ToastContainer />

//         <div className="bg-white h-full overflow-auto">
//           {loading ? (
//             <InfiLoader />
//           ) : (
//             <div className="h-full overflow-auto">
//               {/* TOP BAR */}
//               <div className="sticky top-0 z-20 bg-black/10 px-1.5 lg:px-4 py-2 grid grid-cols-2 md:flex items-center justify-between gap-2 rounded-lg shadow-md flex-wrap md:flex-nowrap">
//                 <button
//                   className="bg-black px-2 text-white rounded-full lg:hidden text-2xl w-10 flex justify-center items-center"
//                   onClick={() => setIsOpenBarCode(true)}
//                 >
//                   <IoBarcodeOutline />
//                 </button>

//                 {/* BARCODE INPUT */}
//                 <form
//                   onSubmit={(e) => e.preventDefault()}
//                   className="hidden md:flex items-center gap-2"
//                 >
//                   <Input.Normal
//                     className="lg:text-[0.875rem] text-xs py-1"
//                     placeholder="Barcode (wait 3s after typing)"
//                     onChange={handleBarcodeSearch}
//                     onKeyPress={(e) => handleKeyPress(e, true)}
//                     value={inputValue}
//                     ref={inputRef}
//                     autoFocus={false}
//                   />
//                   <div className="relative group">
//                     <AiFillInfoCircle className="text-gray-400 hover:text-gray-600 cursor-pointer" />
//                     <div className="absolute hidden group-hover:flex w-max bg-white text-gray-800 text-xs rounded-md py-2 px-3 left-1/2 -translate-x-1/2 top-full mt-2 shadow-lg border border-gray-300 opacity-0 group-hover:opacity-100 transition-opacity z-10">
//                       Wait 3s after STOP typing • Enter = instant
//                       <span className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3 h-3 bg-white border-l border-t border-gray-300 rotate-45"></span>
//                     </div>
//                   </div>
//                 </form>

//                 {/* GLOBAL TEXT SEARCH */}
//                 <div className="w-full col-span-2 md:w-1/2 relative group">
//                   <Input.Normal
//                     type="text"
//                     placeholder="Global Search (wait 3s after typing)"
//                     className="lg:text-[0.875rem] text-xs py-1.5 lg:w-full hover:border-gray-500 transition"
//                     value={filterValue}
//                     onChange={handleGlobalSearch}
//                     onKeyPress={handleKeyPress}
//                     ref={searchInputRef}
//                     autoFocus
//                   />
//                   <BiSearch className="text-lg absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 group-hover:text-black transition" />
//                 </div>

//                 {/* CART + GENERATE - unchanged */}
//                 <div className="flex row-start-1 col-start-2 items-center justify-end gap-2 border-l lg:border-none lg:gap-3">
//                   <div className="relative">
//                     <button
//                       className="p-1.5 flex justify-center items-center text-lg hover:bg-black hover:text-white rounded-full transition"
//                       onClick={() => setViewLive(true)}
//                     >
//                       <RiShoppingCartLine />
//                     </button>
//                     <div className="bg-black text-white text-[0.625rem] w-4 h-4 rounded-full absolute -right-1 -top-1 flex justify-center items-center">
//                       {combinedData.length}
//                     </div>
//                   </div>

//                   {userData?.storeDetails?.storeObjId ? (
//                     <button
//                       className={`w-full text-[0.75rem] lg:text-[0.875rem] lg:p-1.5 lg:px-3 p-1 px-4 rounded ${
//                         combinedData.length === 0
//                           ? "bg-gray-300 text-gray-500 cursor-not-allowed"
//                           : "bg-black text-white hover:bg-gray-800"
//                       }`}
//                       disabled={combinedData.length === 0}
//                       onClick={() => {
//                         setGeneratePdfPopup(true);
//                         UpdateCatalogStatus("catalog_generated");
//                       }}
//                     >
//                       Generate
//                     </button>
//                   ) : (
//                     <button
//                       className="w-full text-[0.75rem] lg:text-[0.875rem] lg:p-1.5 lg:px-3 p-1 px-4 rounded bg-gray-300 text-gray-500 cursor-not-allowed"
//                       disabled
//                       onClick={() => toast.error("No store assigned.")}
//                     >
//                       Generate
//                     </button>
//                   )}
//                 </div>
//               </div>

//               {/* PRODUCT LIST & PAGINATION - unchanged */}
//               <div className="productSection w-full mt-3 md:mt-5">
//                 {data.length === 0 && !loading ? (
//                   <div className="text-center p-4 text-gray-600">
//                     No products found.
//                   </div>
//                 ) : (
//                   <>
//                     <div className="flex md:hidden flex-col gap-2">
//                       {data?.map((item, idx) => (
//                         <div key={item.id} className="flex items-start gap-1">
//                           <label className="p-1 px-2 rounded-sm bg-gray-50 font-medium text-xs">
//                             {idx + 1}
//                           </label>
//                           <div className="flex justify-center items-center w-full">
//                             <img
//                               className="max-h-24 max-w-24 w-2/5 rounded object-cover"
//                               src={item?.image || "/imageNotFound.png"}
//                               alt={item?.title}
//                             />
//                             <div className="p-2 flex-1">
//                               <div className="text-sm truncate">{item?.title}</div>
//                               <div className="text-xs mt-2 bg-gray-50 p-2 rounded">
//                                 <label className="font-medium">Size</label>
//                                 <div className="text-xs mt-1">
//                                   <VariantSku
//                                     item={item}
//                                     sizeHandle={sizeHandle}
//                                     padding="px-2 p-1"
//                                   />
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       ))}
//                     </div>

//                     <div className="md:block hidden relative w-full h-full overflow-y-auto shadow-md sm:rounded-lg">
//                       <table className="w-full text-sm text-left rtl:text-right text-gray-500">
//                         <thead className="text-xs text-gray-700 uppercase bg-gray-50">
//                           <tr>
//                             <th className="px-6 py-3">#</th>
//                             <th className="px-6 py-3">Image</th>
//                             <th className="px-6 py-3">Title</th>
//                             <th className="px-6 py-3">Add by Size</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {data?.map((item, idx) => (
//                             <tr key={item.id} className="border-b hover:bg-gray-50">
//                               <th className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
//                                 {idx + 1}
//                               </th>
//                               <td className="px-6 py-4">
//                                 <label htmlFor={`${item.id}`} className="cursor-pointer">
//                                   <img
//                                     src={item.image || "/imageNotFound.png"}
//                                     alt={item.title}
//                                     className="w-24 rounded object-cover"
//                                   />
//                                 </label>
//                               </td>
//                               <td className="px-6 py-4">
//                                 <label className="cursor-pointer">{item?.title}</label>
//                               </td>
//                               <td className="px-6 py-4">
//                                 <VariantSku item={item} sizeHandle={sizeHandle} />
//                               </td>
//                             </tr>
//                           ))}
//                         </tbody>
//                       </table>
//                     </div>
//                   </>
//                 )}
//               </div>

//               {paginationData && (
//                 <div className="flex justify-center m-1 sticky bottom-0 backdrop-blur-md bg-white/90">
//                   <Pagination
//                     currentPage={currentPage}
//                     totalItems={paginationData?.totalItems || 0}
//                     itemsPerPage={parseInt(itemsPerPage)}
//                     onPageChange={handlePageChange}
//                   />
//                 </div>
//               )}
//             </div>
//           )}
//         </div>

//         {/* CART SIDEBAR & PDF POPUP - unchanged */}
//         <div
//           className={`fixed z-50 bg-white lg:w-1/4 w-11/12 h-[95%] lg:h-screen p-4 lg:p-6 transition-all duration-500
//           ${
//             viewLive
//               ? "opacity-100 translate-x-0 translate-y-0"
//               : "opacity-0 lg:-translate-x-full translate-y-full pointer-events-none"
//           }
//           lg:left-0 lg:top-0 lg:rounded-r-3xl lg:drop-shadow-xl bottom-0 left-1/2 -translate-x-1/2 rounded-t-lg shadow-xl`}
//         >
//           {/* Cart content - unchanged */}
//         </div>

//         {generatePdfPopup && (
//           <Card.AddPopUp removePopUp={() => setGeneratePdfPopup(false)} className="transition-all duration-500" height="auto">
//             {/* PDF content - unchanged */}
//           </Card.AddPopUp>
//         )}
//       </Container>
//     </Layout>
//   );
// };

// export const VariantSku = ({ item, sizeHandle, padding, margin }) => {
//   return (
//     <label htmlFor={`${item.id}`} className="cursor-pointer flex flex-wrap gap-2">
//       {item?.variants?.map((v) => (
//         <button
//           className={`bg-transparent border text-gray-600 rounded hover:bg-blue-50 hover:border-blue-300 transition ${
//             padding || "p-1.5 px-3"
//           } ${margin || "m-1"} text-xs`}
//           onClick={() => sizeHandle(v._id)}
//           key={v._id}
//         >
//           {v.size}
//         </button>
//       ))}
//     </label>
//   );
// };

// export default CreateCatalog;

import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useContext,
} from "react";
import axios from "axios";
import "./createCatalog.css";
import "react-toastify/dist/ReactToastify.css";
import PDFComponent from "./PDFComponent";
import Layout, { Container } from "../../components/layout";
import { ToastContainer, toast } from "react-toastify";
import { RiCloseLargeFill, RiShoppingCartLine } from "react-icons/ri";
import { BiSearch } from "react-icons/bi";
import BarcodeScanner from "./barcode";
import { IoBarcodeOutline, IoCloseOutline } from "react-icons/io5";
import { AiFillInfoCircle } from "react-icons/ai";
import { InfiLoader } from "../../components/loader";
import { apiurl } from "../../config/config";
import Card from "../../components/card";
import Input from "../../components/inputContainer";
import { PdfContext } from "./pdfContext";
import Error from "../../components/error";
import { MdOutlinePerson, MdOutlinePhone } from "react-icons/md";
import Pagination from "../../components/pagination";
import AllPdfs from "./allPdfs";
import { useUser } from "../../config/userProvider";
import { FaTrash } from "react-icons/fa6";
import svg from "../../components/svg";
import loader from "../../components/loader";
import ImageMagnifier from "../../components/imageMagnifier";

const CreateCatalog = () => {
  const { userData } = useUser();
  const { choosedPdf } = useContext(PdfContext);
  const vendorObjId = userData?.vendorDetails?.vendorObjId;

  /* --------------------------------------------------------------
     STATE
  -------------------------------------------------------------- */
  const [inputValue, setInputValue] = useState("");
  const [data, setData] = useState([]);
  const [checkedItems, setCheckedItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sendingLoader, setSendingLoader] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [combinedData, setCombinedData] = useState([]);
  const [viewLive, setViewLive] = useState(false);
  const [generatePdfPopup, setGeneratePdfPopup] = useState(false);
  const [filterValue, setFilterValue] = useState("");
  const [storeManagerPhoneInput, setStoreManagerPhoneInput] = useState("");
  const [storeManagerInput, setStoreManagerInput] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationData, setPaginationData] = useState("");
  const [pdfFile, setPdfFile] = useState();
  const [isOpenBarCode, setIsOpenBarCode] = useState(false);
  const [barCodeResult, setBarCodeResult] = useState("");
  const [barcodeData, setBarCodeData] = useState([]);
  const [isBarCodeProductList, setIsBarCodeProductList] = useState(false);
  const { isPersonalize, setIsPersonalize } = useUser();
  const [error, setError] = useState("");
  const [customerInformation, setCustomerInformation] = useState({});
  const [sending, setSending] = useState(false);

  const [position, setPosition] = useState({ x: 0, y: 0, show: false });
  const imgRef = useRef(null);

  const handleMouseMove = (e) => {
    if (!imgRef.current) return;

    const img = imgRef.current;
    const { left, top, width: w, height: h } = img.getBoundingClientRect();

    const x = ((e.clientX - left) / w) * 100;
    const y = ((e.clientY - top) / h) * 100;

    setPosition({ x, y, show: true });
  };

  const handleMouseLeave = () => {
    setPosition((prev) => ({ ...prev, show: false }));
  };

  /* --------------------------------------------------------------
     **FOCUS MANAGEMENT STATE** - NEW!
  -------------------------------------------------------------- */
  const [activeInput, setActiveInput] = useState("global"); // 'barcode' | 'global'
  const inputRef = useRef(null);
  const searchInputRef = useRef(null);

  /* --------------------------------------------------------------
     **FIXED DEBOUNCE REFS**
  -------------------------------------------------------------- */
  const barcodeTimeoutRef = useRef(null);
  const textTimeoutRef = useRef(null);

  /* --------------------------------------------------------------
     **INITIAL FOCUS - ONE TIME ONLY** ✅
  -------------------------------------------------------------- */
  useEffect(() => {
    // **ONLY ONCE when component mounts**
    searchInputRef.current?.focus();
    setActiveInput("global");
  }, []); // **EMPTY ARRAY = ONE TIME ONLY**

  /* --------------------------------------------------------------
     LOCAL STORAGE
  -------------------------------------------------------------- */
  useEffect(() => {
    const saved = localStorage.getItem("selectedItems");
    if (saved) setSearchData(JSON.parse(saved));
  }, []);

  useEffect(() => {
    localStorage.setItem("selectedItems", JSON.stringify(searchData));
  }, [searchData]);

  /* --------------------------------------------------------------
     **RESTORE FOCUS AFTER SEARCH** ✅
  -------------------------------------------------------------- */
  useEffect(() => {
    if (loading) return; // Don't focus during loading

    // **RESTORE FOCUS TO ACTIVE INPUT**
    if (activeInput === "barcode" && inputRef.current) {
      inputRef.current.focus();
    } else if (activeInput === "global" && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [data, loading, activeInput]); // **Runs after search completes**

  /* --------------------------------------------------------------
     FETCH PRODUCT LIST
  -------------------------------------------------------------- */
  const fetchProductList = useCallback(() => {
    if (!vendorObjId || filterValue || inputValue) return;
    setLoading(true);
    const payload = JSON.stringify({
      vendorObjId,
      page: currentPage,
      limit: parseInt(itemsPerPage),
    });

    const config = {
      method: "post",
      url: `${apiurl}/admin/v1/product/get/catalog`,
      headers: { "Content-Type": "application/json" },
      data: payload,
    };

    axios
      .request(config)
      .then((res) => {
        if (res?.data?.products) {
          setData(res.data.products);
          setPaginationData(res.data.pagination);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        toast.error("Failed to fetch products");
        setLoading(false);
      });
  }, [vendorObjId, currentPage, itemsPerPage, filterValue, inputValue]);

  useEffect(() => {
    fetchProductList();
  }, [fetchProductList]);

  /* --------------------------------------------------------------
     SEARCH API
  -------------------------------------------------------------- */
  const fetchSearchResults = useCallback(
    async (
      term,
      page = currentPage,
      limit = itemsPerPage,
      isBarcode = false
    ) => {
      if (!term || !vendorObjId) {
        setData([]);
        setPaginationData("");
        return;
      }

      setLoading(true);
      try {
        const paramKey = isBarcode ? "sku" : "search";
        const url = `${apiurl}/admin/v1/product/search?vendorObjId=${vendorObjId}&${paramKey}=${encodeURIComponent(
          term
        )}&page=${page}&limit=${limit}`;

        const res = await axios.get(url, {
          headers: { "Content-Type": "application/json" },
        });

        if (res?.data?.products) {
          setData(res.data.products);
          setPaginationData(res.data.pagination || {});
        } else {
          setData([]);
          setPaginationData("");
        }
      } catch (err) {
        console.error(err);
        toast.error("Failed to fetch search results");
        setData([]);
        setPaginationData("");
      } finally {
        setLoading(false);
      }
    },
    [vendorObjId, currentPage, itemsPerPage]
  );

  /* --------------------------------------------------------------
     DEBOUNCE FUNCTIONS
  -------------------------------------------------------------- */
  const debouncedBarcodeSearch = useCallback(
    (term) => {
      if (barcodeTimeoutRef.current) clearTimeout(barcodeTimeoutRef.current);
      barcodeTimeoutRef.current = setTimeout(() => {
        fetchSearchResults(term, 1, itemsPerPage, true);
      }, 3000);
    },
    [fetchSearchResults, itemsPerPage]
  );

  const debouncedTextSearch = useCallback(
    (term) => {
      if (textTimeoutRef.current) clearTimeout(textTimeoutRef.current);
      textTimeoutRef.current = setTimeout(() => {
        fetchSearchResults(term, 1, itemsPerPage, false);
      }, 3000);
    },
    [fetchSearchResults, itemsPerPage]
  );

  /* --------------------------------------------------------------
     **INPUT HANDLERS WITH FOCUS TRACKING** ✅
  -------------------------------------------------------------- */
  const handleBarcodeSearch = (e) => {
    const val = e.target.value;
    setInputValue(val);
    setActiveInput("barcode"); // **MARK AS ACTIVE**
    setCurrentPage(1);

    if (val) {
      debouncedBarcodeSearch(val);
    } else {
      if (barcodeTimeoutRef.current) clearTimeout(barcodeTimeoutRef.current);
      setData([]);
      setPaginationData("");
      fetchProductList();
    }
  };

  const handleGlobalSearch = (e) => {
    const val = e.target.value;
    setFilterValue(val);
    setActiveInput("global"); // **MARK AS ACTIVE**
    setCurrentPage(1);

    if (val) {
      debouncedTextSearch(val);
    } else {
      if (textTimeoutRef.current) clearTimeout(textTimeoutRef.current);
      setData([]);
      setPaginationData("");
      fetchProductList();
    }
  };

  const handleKeyPress = (e, isBarcode = false) => {
    if (e.key === "Enter") {
      const term = isBarcode ? inputValue : filterValue;
      if (term) {
        if (isBarcode && barcodeTimeoutRef.current)
          clearTimeout(barcodeTimeoutRef.current);
        if (!isBarcode && textTimeoutRef.current)
          clearTimeout(textTimeoutRef.current);
        fetchSearchResults(term, 1, itemsPerPage, isBarcode);
      }
    }
  };

  /* --------------------------------------------------------------
     PAGINATION
  -------------------------------------------------------------- */
  useEffect(() => {
    if (filterValue) {
      debouncedTextSearch(filterValue);
    } else if (inputValue) {
      debouncedBarcodeSearch(inputValue);
    }
  }, [
    currentPage,
    itemsPerPage,
    filterValue,
    inputValue,
    debouncedTextSearch,
    debouncedBarcodeSearch,
  ]);

  /* --------------------------------------------------------------
     BARCODE SCANNER
  -------------------------------------------------------------- */
  const handleBarcodeDetected = useCallback(
    (code) => {
      setBarCodeResult(code);
      setInputValue(code);
      setActiveInput("barcode"); // **MARK AS ACTIVE**
      debouncedBarcodeSearch(code);
    },
    [debouncedBarcodeSearch]
  );

  /* --------------------------------------------------------------
     CLEANUP
  -------------------------------------------------------------- */
  useEffect(() => {
    return () => {
      if (barcodeTimeoutRef.current) clearTimeout(barcodeTimeoutRef.current);
      if (textTimeoutRef.current) clearTimeout(textTimeoutRef.current);
    };
  }, []);

  /* --------------------------------------------------------------
     REST OF CODE (unchanged)
  -------------------------------------------------------------- */
  useEffect(() => {
    const uniq = [];
    const ids = new Set();
    [...selectedItems, ...searchData].forEach((i) => {
      if (!ids.has(i._id)) {
        uniq.push(i);
        ids.add(i._id);
      }
    });
    setCombinedData(uniq);
  }, [selectedItems, searchData]);

  const handleCheckboxChange = (id) => {
    setCheckedItems((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  useEffect(() => {
    const json = data.filter((p) => checkedItems.includes(p.id));
    setSelectedItems(json);
  }, [data, checkedItems]);

  const sizeHandle = (variantId) => {
    const filtered = data.flatMap((p) =>
      p.variants
        .filter((v) => v._id === variantId)
        .map((v) => ({
          ...v,
          productId: p.id,
          productObjId: p._id,
          productImage: p.image,
          title: p.title,
        }))
    );

    setSearchData((prev) => {
      const existing = new Set(prev.map((i) => i._id));
      const added = filtered.filter((i) => !existing.has(i._id));
      return [...prev, ...added];
    });
  };

  const removeHandle = (id) => {
    setSearchData((prev) => prev.filter((i) => i._id !== id));
  };

  const handlePageChange = (page) => setCurrentPage(page);

  const CustomerInputHandler = (e) => {
    const { name, value } = e.target;
    let v = value;
    if (name === "customerPhone") {
      let digits = value.replace(/[^0-9]/g, "");
      if (digits.startsWith("91")) digits = digits.slice(2);
      digits = digits.slice(0, 10);
      v = "91" + digits;
    }
    setCustomerInformation((prev) => ({ ...prev, [name]: v }));
  };

  const UpdateCatalogStatus = (status) => {
    const products = combinedData.map((i) => ({
      productObjId: i.productObjId || "",
      productId: i.productId || "",
      varientId: i.id || "",
      varientObjId: i._id || "",
      sku: i.sku || "",
      barcode: i.barcode || "",
    }));

    if (!userData) return;

    const tags = [choosedPdf];
    const payload = JSON.stringify({
      vendorObjId,
      ...(userData.type === "superadmin" && {
        storeObjId: userData?.storeDetails?.storeObjId,
      }),
      userObjId: userData?._id,
      actionDetails: { products, type: status, description: "", tags },
      catalogDetails: { name: choosedPdf },
      customerDetails: {
        name: customerInformation.customerName || "",
        phone: customerInformation.customerPhone || "",
        customerEmail: customerInformation.customerEmail || "",
      },
    });

    const cfg = {
      method: "post",
      url: `${apiurl}/admin/v1/analytic/create`,
      headers: { "Content-Type": "application/json" },
      data: payload,
    };

    axios.request(cfg).catch(console.error);
  };

  const EmailSendHandler = async () => {
    if (
      !pdfFile ||
      !customerInformation?.customerName ||
      !customerInformation?.customerEmail
    ) {
      setError("Please fill in all required fields");
      return;
    }
    setSendingLoader(true);
    try {
      const fd = new FormData();
      fd.append("pdf", pdfFile);
      fd.append("name", customerInformation.customerName);
      fd.append("email", customerInformation.customerEmail);

      const res = await axios.post(
        `${apiurl}/admin/v1/marketing/EmailWithFileAttachment`,
        fd,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (res.data.success) {
        setGeneratePdfPopup(false);
        UpdateCatalogStatus("catalog_sent_email");
      } else setError(res.data.message);
    } catch (e) {
      setError("Failed to send email.");
    } finally {
      setSendingLoader(false);
    }
  };

  const WhatsappSendHandler = async () => {
    if (!customerInformation?.customerPhone || !pdfFile) {
      setError("Phone number or PDF file is missing!");
      return;
    }
    setSendingLoader(true);
    try {
      const fileUrl = await FileLinkHandler(pdfFile);
      if (!fileUrl) throw new Error("Upload failed");

      const msg = `Hi ${customerInformation.customerName}, please find the attached PDF here: ${fileUrl}`;
      const wa = `https://wa.me/${
        customerInformation.customerPhone
      }?text=${encodeURIComponent(msg)}`;
      window.open(wa, "_blank");
      UpdateCatalogStatus("catalog_sent_whatsapp");
    } catch (e) {
      setError("Failed to send WhatsApp.");
    } finally {
      setSendingLoader(false);
    }
  };

  const FileLinkHandler = async (file) => {
    if (!file) return null;
    const fd = new FormData();
    fd.append("file", file);
    try {
      const res = await axios.post(`${apiurl}/admin/v1/media/document`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return res.data.success ? res.data.fileUrl : null;
    } catch {
      return null;
    }
  };

  useEffect(() => {
    if (error) setTimeout(() => setError(""), 5000);
  }, [error]);

  useEffect(() => {
    if (userData?.storeDetails) {
      setStoreManagerPhoneInput(userData?.phone || "");
      setStoreManagerInput(userData?.name || "");
    }
  }, [userData]);

  const sendStoreData = {
    storename: userData?.storeDetails?.storeName || "",
    managername: storeManagerInput || "",
    storePhone: storeManagerPhoneInput || "",
    storeAddress: userData?.storeDetails?.storeAddress || "",
    storeCode: userData?.storeDetails?.storeCode || "N/A",
  };

  const clearCart = () => {
    setSearchData([]);
    setSelectedItems([]);
    setCombinedData([]);
    setCheckedItems([]);
    localStorage.removeItem("selectedItems");
    toast.success("Cart cleared!");
  };

  /* --------------------------------------------------------------
     RENDER
  -------------------------------------------------------------- */
  return (
    <Layout>
      <Container>
        {sendingLoader && <InfiLoader />}

        {/* BARCODE SCANNER POPUP */}
        {isOpenBarCode && (
          <div className="backdrop-blur-md bg-black/60 fixed inset-0 z-20 flex items-center justify-center">
            <button
              className="absolute top-4 right-4 p-1 border border-white rounded-md text-white"
              onClick={() => setIsOpenBarCode(false)}
            >
              <RiCloseLargeFill />
            </button>
            <div className="mt-[10%] md:mt-0 m-5 rounded-lg overflow-hidden p-4 relative shadow-lg">
              <BarcodeScanner
                barCodeResult={barCodeResult}
                setBarCodeResult={setBarCodeResult}
                barcodeData={barcodeData}
                setBarCodeData={setBarCodeData}
                combinedData={combinedData}
                setCombinedData={setCombinedData}
                onBarcodeDetected={handleBarcodeDetected}
              />
            </div>

            {isBarCodeProductList && (
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="bg-white rounded-xl w-10/12 max-h-[80vh] overflow-auto p-5">
                  {barcodeData?.map((it, idx) => (
                    <div key={idx} className="border-b py-2">
                      {it.title}
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="absolute bottom-5 w-full flex items-center gap-2 px-3">
              {barCodeResult && (
                <div className="bg-white w-11/12 p-2 py-3 rounded-lg text-center">
                  {barCodeResult} - Search in 3s ⏳
                </div>
              )}
              <button
                className="bg-blue-500 text-white p-3 rounded-full text-4xl"
                onClick={() => setIsBarCodeProductList(!isBarCodeProductList)}
              >
                {isBarCodeProductList ? (
                  <IoCloseOutline />
                ) : (
                  <IoBarcodeOutline />
                )}
              </button>
              <button
                className="bg-black text-white p-3 rounded-full text-xl"
                onClick={() => setViewLive(!viewLive)}
              >
                <RiShoppingCartLine />
              </button>
            </div>
          </div>
        )}

        <ToastContainer />

        <div className="bg-white h-full overflow-hidden">
          {loading ? (
            <InfiLoader />
          ) : (
            <div className="h-full overflow-y-auto overflow-x-hidden">
              {/* TOP BAR */}
              <div className="sticky top-0 z-20 bg-gray-100 px-1.5 lg:px-4 py-2 grid grid-cols-2 md:flex items-center justify-between gap-2 rounded-lg shadow-md flex-wrap md:flex-nowrap">
                <button
                  className="bg-black px-2 text-white rounded-full lg:hidden text-2xl w-10 flex justify-center items-center"
                  onClick={() => setIsOpenBarCode(true)}
                >
                  <IoBarcodeOutline />
                </button>

                {/* BARCODE INPUT - NO AUTOFOCUS */}
                <form
                  onSubmit={(e) => e.preventDefault()}
                  className="hidden md:flex items-center gap-2"
                >
                  <Input.Normal
                    className="lg:text-[0.875rem] text-xs py-1"
                    // placeholder="Barcode (wait 3s after typing)"
                    placeholder="SKU (wait 3s after typing)"
                    onChange={handleBarcodeSearch}
                    onKeyPress={(e) => handleKeyPress(e, true)}
                    value={inputValue}
                    ref={inputRef}
                    autoFocus={false} // **NEVER STEALS FOCUS**
                  />
                  <div className="relative group">
                    <AiFillInfoCircle className="text-gray-400 hover:text-gray-600 cursor-pointer" />
                    <div className="absolute hidden group-hover:flex w-max bg-white text-gray-800 text-xs rounded-md py-2 px-3 left-1/2 -translate-x-1/2 top-full mt-2 shadow-lg border border-gray-300 opacity-0 group-hover:opacity-100 transition-opacity z-10">
                      Wait 3s after STOP typing • Enter = instant
                      <span className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3 h-3 bg-white border-l border-t border-gray-300 rotate-45"></span>
                    </div>
                  </div>
                </form>

                {/* GLOBAL SEARCH - NO AUTOFOCUS */}
                <div className="w-full col-span-2 md:w-1/2 relative group">
                  <Input.Normal
                    type="text"
                    placeholder="Global Search (wait 3s after typing)"
                    className="lg:text-[0.875rem] text-xs py-1.5 lg:w-full hover:border-gray-500 transition"
                    value={filterValue}
                    onChange={handleGlobalSearch}
                    onKeyPress={handleKeyPress}
                    ref={searchInputRef}
                    autoFocus={false} // **REMOVED - controlled by useEffect**
                  />
                  <BiSearch className="text-lg absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 group-hover:text-black transition" />
                </div>

                {/* CART + GENERATE */}
                <div className="flex row-start-1 col-start-2 items-center justify-end gap-2 border-l lg:border-none lg:gap-3">
                  <div className="relative">
                    <button
                      className="p-1.5 flex justify-center items-center text-lg hover:bg-black hover:text-white rounded-full transition"
                      onClick={() => setViewLive(true)}
                    >
                      <RiShoppingCartLine />
                    </button>
                    <div className="bg-black text-white text-[0.625rem] w-4 h-4 rounded-full absolute -right-1 -top-1 flex justify-center items-center">
                      {combinedData.length}
                    </div>
                  </div>

                  {/* {userData?.storeDetails?.storeObjId ? (
                    <button
                      className={`w-full text-[0.75rem] lg:text-[0.875rem] lg:p-1.5 lg:px-3 p-1 px-4 rounded ${
                        combinedData.length === 0
                          ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                          : "bg-black text-white hover:bg-gray-800"
                      }`}
                      disabled={combinedData.length === 0}
                      onClick={() => {
                        setGeneratePdfPopup(true);
                        UpdateCatalogStatus("catalog_generated");
                      }}
                    >
                      Generate
                    </button>
                  ) : (
                    <button
                      className="w-full text-[0.75rem] lg:text-[0.875rem] lg:p-1.5 lg:px-3 p-1 px-4 rounded bg-gray-300 text-gray-500 cursor-not-allowed"
                      disabled
                      onClick={() => toast.error("No store assigned.")}
                    >
                      Generate
                    </button>
                  )} */}
                  <button
                    className={`w-full text-[0.75rem] lg:text-[0.875rem] lg:p-1.5 lg:px-3 p-1 px-4 rounded ${
                      combinedData.length === 0
                        ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                        : "bg-black text-white hover:bg-gray-800"
                    }`}
                    disabled={combinedData.length === 0}
                    onClick={() => {
                      setGeneratePdfPopup(true);
                      UpdateCatalogStatus("catalog_generated");
                    }}
                  >
                    Generate
                  </button>
                </div>
              </div>

              {/* PRODUCT LIST & PAGINATION - unchanged */}
              <div className="productSection w-full mt-3 md:mt-5">
                {data.length === 0 && !loading ? (
                  <div className="text-center p-4 text-gray-600">
                    No products found.
                  </div>
                ) : (
                  <>
                    <div className="flex md:hidden flex-col gap-2">
                      {data?.map((item, idx) => (
                        <div key={item.id} className="flex items-start gap-1">
                          <label className="p-1 px-2 rounded-sm bg-gray-50 font-medium text-xs">
                            {idx + 1}
                          </label>
                          <div className="flex justify-center items-center w-full">
                            <img
                              className="max-h-24 max-w-24 w-2/5 rounded object-cover"
                              src={item?.image || "/imageNotFound.png"}
                              alt={item?.title}
                            />
                            <div className="p-2 flex-1">
                              <div className="text-sm text-wrap break-words">
                                {item?.title}
                              </div>
                              <div className="text-xs mt-2 bg-gray-50 p-2 rounded">
                                <label className="font-medium">Size</label>
                                <div className="text-xs mt-1">
                                  <VariantSku
                                    item={item}
                                    sizeHandle={sizeHandle}
                                    padding="px-2 p-1"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    <div className="md:block hidden relative w-full h-full overflow-y-auto shadow-md sm:rounded-lg">
                      <table className="w-full text-sm text-left rtl:text-right text-gray-500">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                          <tr>
                            <th className="px-6 py-3">#</th>
                            <th className="px-6 py-3">Image</th>
                            <th className="px-6 py-3">Title</th>
                            <th className="px-6 py-3">Add by Size</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data?.map((item, idx) => (
                            <tr
                              key={item.id}
                              className="border-b hover:bg-gray-50"
                            >
                              <th className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                {idx + 1}
                              </th>
                              <td className="px-6 py-4">
                                <label
                                  htmlFor={`${item.id}`}
                                  className="cursor-pointer"
                                >
                                  {/* <img
                                    src={item.image || "/imageNotFound.png"}
                                    alt={item.title}
                                    className="w-24 rounded object-cover"
                                  /> */}
                                  <ImageMagnifier
                                    src={item.image || "/imageNotFound.png"}
                                    alt={item.title}
                                    width={120}
                                    height={120}
                                    zoom={3}
                                    magnifierSize={400}
                                  />
                                </label>
                              </td>
                              <td className="px-6 py-4">
                                <label className="cursor-pointer">
                                  {item?.title}
                                </label>
                              </td>
                              <td className="px-6 py-4">
                                <VariantSku
                                  item={item}
                                  sizeHandle={sizeHandle}
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
              </div>

              {paginationData && (
                <div className="flex justify-center m-1 sticky bottom-0 z-20 backdrop-blur-md bg-white/90">
                  <Pagination
                    currentPage={currentPage}
                    totalItems={paginationData?.totalItems || 0}
                    itemsPerPage={parseInt(itemsPerPage)}
                    onPageChange={handlePageChange}
                  />
                </div>
              )}
            </div>
          )}
        </div>

        {/* CART SIDEBAR */}
        <div
          className={`fixed z-50 bg-white lg:w-1/4 w-full h-[90%] lg:h-screen p-4 lg:p-6 transition-all duration-500
          ${
            viewLive
              ? "opacity-100 translate-x-0 translate-y-0"
              : "opacity-0 lg:-translate-x-full translate-y-full pointer-events-none"
          }
          lg:left-0 lg:top-0 lg:rounded-r-3xl lg:drop-shadow-xl bottom-0 right-0 rounded-t-lg shadow-xl`}
        >
          <div className="flex justify-between items-center">
            <p className="flex items-center gap-2">
              <span className="text-xl font-semibold">Cart</span>
              <span className="bg-blue-100 border border-blue-300 text-blue-600 px-2 rounded text-xs">
                {combinedData.length}
              </span>
            </p>
            <div className="flex items-center gap-3">
              {combinedData.length > 0 && (
                <button
                  className="text-gray-500 hover:text-red-500 transition flex items-center gap-1 text-sm"
                  onClick={clearCart}
                >
                  <FaTrash className="w-4 h-4" />
                  Clear
                </button>
              )}
              <button
                className="text-gray-400 hover:text-black transition"
                onClick={() => setViewLive(false)}
              >
                <RiCloseLargeFill />
              </button>
            </div>
          </div>

          {combinedData.length > 0 ? (
            <div className="flex flex-col gap-4 my-4 overflow-scroll h-full">
              {combinedData.map((item) => (
                <div className="border-b flex gap-4 py-4" key={item._id}>
                  <div>
                    <img
                      src={item.productImage || "/imageNotFound.png"}
                      alt={item.title}
                      className="rounded w-20 h-20 object-cover"
                    />
                  </div>
                  <div className="flex justify-between w-full">
                    <div className="flex flex-col gap-1 items-start">
                      <div className="flex flex-col items-start">
                        <p className="text-xs bg-gray-50 px-2 py-0.5 rounded text-gray-500">
                          <i>{item.barcode}</i>
                        </p>
                        <label className="text-sm font-semibold">
                          {item.title}
                        </label>
                      </div>
                      <p className="border p-1 px-2 rounded text-xs text-gray-600">
                        {item.size}
                      </p>
                    </div>
                    <button
                      className="text-gray-500 hover:text-red-500"
                      onClick={() => removeHandle(item._id)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        className="w-5 h-5"
                      >
                        <path d="M3 6h18" />
                        <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                        <path d="M6 6v14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6" />
                        <path d="M9 11v6" />
                        <path d="M15 11v6" />
                      </svg>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="w-full h-full flex justify-center items-center">
              <div className="bg-gray-50 text-gray-600 rounded-md border border-gray-300 p-6">
                <h2 className="text-sm">Cart is empty!</h2>
              </div>
            </div>
          )}
        </div>

        {generatePdfPopup && (
          <Card.AddPopUp
            removePopUp={() => setGeneratePdfPopup(false)}
            className="transition-all duration-500"
            height="auto"
          >
            <div className="p-4 py-2 rounded text-xs md:text-sm">
              <div className="flex justify-between items-start sticky top-0 bg-white">
                <div className="flex flex-col text-gray-800">
                  <div className="font-semibold md:font-bold text-lg md:text-xl capitalize">
                    {userData?.storeDetails?.storeName || "Store Name"}
                  </div>
                </div>
              </div>
              <div className="mb-4 gap-2 md:gap-4 shadow border rounded-md p-3 mt-4">
                <p className="font-semibold text-lg">Store Information</p>
                <div className="p-3 text-gray-600 flex flex-col gap-2">
                  <div className="grid grid-cols-2 gap-2">
                    <p className="flex items-center gap-2 font-semibold">
                      <MdOutlinePerson className="text-lg" />
                      Manager Name
                    </p>
                    <p>{storeManagerInput || "N/A"}</p>
                  </div>
                  <div className="grid grid-cols-2 gap-2">
                    <p className="flex items-center gap-2 font-semibold">
                      <MdOutlinePhone className="text-lg" />
                      Phone
                    </p>
                    <p>{storeManagerPhoneInput || "N/A"}</p>
                  </div>
                </div>
              </div>
              <div className="my-4 bg-white">
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-2">
                  <label className="inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      className="sr-only peer"
                      checked={isPersonalize}
                      onChange={(e) => setIsPersonalize(e.target.checked)}
                    />
                    <div className="relative w-9 h-5 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-600"></div>
                    <span className="ml-3 text-sm font-medium text-gray-900">
                      Personalize
                    </span>
                  </label>
                  <div className="text-xs md:text-sm px-3 py-1 rounded bg-blue-50 border border-blue-400 text-blue-700">
                    Customer Information
                  </div>
                </div>
                {isPersonalize && (
                  <div className="flex flex-col gap-2 my-3 transition-all duration-500">
                    <div className="flex md:flex-row flex-col gap-2 md:gap-4">
                      <Input.Normal
                        label="Customer Name"
                        type="text"
                        name="customerName"
                        placeholder="Name"
                        value={customerInformation?.customerName || ""}
                        onChange={CustomerInputHandler}
                      />
                      <Input.Normal
                        label="Phone Number"
                        type="text"
                        name="customerPhone"
                        placeholder="Phone Number"
                        value={customerInformation?.customerPhone || ""}
                        onChange={CustomerInputHandler}
                      />
                    </div>
                    <Input.Normal
                      label="Email"
                      type="email"
                      name="customerEmail"
                      placeholder="Email"
                      value={customerInformation?.customerEmail || ""}
                      onChange={CustomerInputHandler}
                    />
                  </div>
                )}
              </div>
              <div className="bg-gray-50 border rounded-md p-3">
                <Input.Normal
                  label="Choose PDF Template"
                  isInput={false}
                  labelClassName="mt-2 p-0"
                />
                <div className="flex justify-evenly gap-5 md:mt-1">
                  <AllPdfs
                    data={{ Product: combinedData, Store: sendStoreData }}
                  />
                </div>
              </div>
              <div className="flex justify-between items-center gap-3 mt-3">
                {isPersonalize && (
                  <div className="flex items-center gap-2 mt-3 capitalize">
                    <button
                      className="px-3 py-1 border rounded-md flex items-center gap-2 hover:text-red-700 text-nowrap"
                      onClick={EmailSendHandler}
                    >
                      <svg.gmail className="cursor-pointer" />
                      {sending === true ? (
                        <loader.staggerCircle color="#fd1f1a" />
                      ) : null}
                    </button>
                    <button
                      className="px-3 py-1.5 border rounded-md flex cursor-pointer items-center gap-2 hover:text-green-700 text-nowrap w-14"
                      onClick={WhatsappSendHandler}
                    >
                      <img src="/whatsappShare.png" className="w-8 h-auto" />
                    </button>
                  </div>
                )}
                <PDFComponent
                  data={{
                    Product: combinedData,
                    Store: sendStoreData,
                    Customer: customerInformation,
                  }}
                  submitData={UpdateCatalogStatus}
                  setPdfFile={setPdfFile}
                  pdfFile={pdfFile}
                />
              </div>
              {error && <Error err={error} absolute className="mt-2" />}
            </div>
          </Card.AddPopUp>
        )}
      </Container>
    </Layout>
  );
};

export const VariantSku = ({ item, sizeHandle, padding, margin }) => {
  return (
    <label
      htmlFor={`${item.id}`}
      className="cursor-pointer flex flex-wrap gap-2"
    >
      {item?.variants?.map((v) => (
        <button
          className={`bg-transparent border text-gray-600 rounded hover:bg-blue-50 hover:border-blue-300 transition ${
            padding || "p-1.5 px-3"
          } ${margin || "m-1"} text-xs`}
          onClick={() => sizeHandle(v._id)}
          key={v._id}
        >
          {v.size}
        </button>
      ))}
    </label>
  );
};

export default CreateCatalog;
